/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable max-len */
/* eslint-disable react/prop-types */
import {
  Button,
  Card,
  Checkbox,
  Col,
  DatePicker,
  Form,
  Input,
  List,
  Menu,
  Modal,
  Progress,
  Row,
  Select as AntdSelect,
  Spin,
  Table as AntTable,
  Tabs,
  Tag,
  Typography,
  message,
  notification,
} from 'antd';
import {
  deleteAdministracionDePlaza,
  eliminarPermanenteAdministracionDePlaza,
  getAdministracionDePlaza,
  getAdministracionDePlazasvistaOptimized,
  getSujetosDeNomina,
  patchAdministracionDePlaza,
  postAdministracionDePlaza,
  putAutorizarPlazaMasiva,
} from 'api/catalogos/admnistracionDePlazas';
import API, { baseURL } from 'utils/api';
import store from 'store/store';
import { selectUser } from 'store/auth';
import {
  getMotivosDeMovimientosDeEmpleados,
} from 'api/catalogos/motivoDeMovimientoDeEmpleados';
import { getTiposDeMovimientosDeEmpleados } from 'api/catalogos/tiposDeMovimientosDeEmpleados';
import { getTiposDeMovimientoDePersonal } from 'api/catalogos/tiposDeMovimientoDePersonal';
import {
  getPlazasvistaOptimized,
  getPlazavistaOptimized,
  patchPlaza,
} from 'api/catalogos/plazas';
import { getDatoOperacionalDelEmpleado, getDatoOperacionalPorEmpleado, getDatoOperacionalPorEmpleadoOptimized } from 'api/estructuraOrganizacional/datosOperacionalesDeEmpleados';
import { getEmpleado, getEmpleadosOptimized, getEmpleadosvistaOptimized } from 'api/estructuraOrganizacional/empleados';
import { getBecarioVistaoptimizado } from 'api/catalogos/Becario';
import { getDatoOperacionalPorBecario, getDatoOperacionalPorBecarioOptimized } from 'api/estructuraOrganizacional/datosOperacionalesDeBecario';
import { getHonorarioAsimiladoVistaoptimizado } from 'api/catalogos/HonorarioAsimilado';
import { getDatoOperacionalPorHonorarioAsimilado, getDatoOperacionalPorHonorarioAsimiladoOptimized } from 'api/estructuraOrganizacional/datosOperacionalesDeHonorarioAsimilado';
import { getCaracteresDeNombramiento } from 'api/catalogos/CaracterDeNombramiento';
import { getPeriodosFiscales } from 'api/configuraciones/periodosFiscales';
import { getPeriodosDeNominasDetalles } from 'api/nominas/periodos/periodosDeNominasDetalle';

import CurrencyInput from 'components/CurrencyInput';
import FormSubmitControls from 'components/FormSubmitControls';
import useSeguimientoDeRegistro from 'hooks/useSeguimientoDeRegistro';
import Select from 'components/Select';
import Table from 'components/Table';
import moment from 'moment';
import getProcesoEnCursoTerminado from 'api/catalogos/ProcesoEnCursoTerminado';
import React, { useEffect, useRef, useState } from 'react';
import {
  ESTADO_PLAZA_ASIGNADA,
  ESTADO_PLAZA_AUTORIZADA,
  ESTADO_PLAZA_DISPONIBLE,
  ESTATUS_ACTIVO,
  ESTATUS_AUTORIZADO,
  ESTATUS_CANCELADO,
  ESTATUS_INACTIVO,
  TIPO_MOVIMIENTO_ALTA,
  TIPO_MOVIMIENTO_CAMBIO,
} from 'utils/constants';
import currencyFormatter from 'utils/currencyFormatter';
import { formatReceived, formatReceivedValues } from 'utils/formatValues';
import { onAlert, onError, onSuccess } from 'utils/handlers';
import { SLUG_PATTERN } from 'utils/patterns';
import ModalUnAsignPlaza from 'components/ModalUnAsignPlaza';
import { getTiposDeActividades } from 'api/catalogos/TiposDeActividades';
import { getEstadosPlazas } from 'api/catalogos/estadosPlazas';
import {
  CheckCircleOutlined, CloseCircleOutlined, DownloadOutlined, EyeOutlined,
  FileExcelOutlined, UserDeleteOutlined,
} from '@ant-design/icons';
import * as XLSX from 'xlsx';
import { getTiposAsignacion } from 'api/catalogos/TipoAsignacionDePlaza';
import { getUsuariosLimitaciones } from 'api/usuarios/usuariosLimitaciones';
import { getLimitacionesAdministracionPlazas } from 'api/usuarios/limitacionAdministracionPlazas';
import { obtenerMiPasoDeAutorizacion } from 'utils/pasoAutorizacion';
import { getLiquidacionesEmpleados } from 'api/nominas/liquidaciones/liquidacionesEmpleados';
import { getLiquidaciones } from 'api/nominas/liquidaciones/liquidaciones';
import { getMotivosDeLiquidaciones } from 'api/catalogos/motivosDeLiquidaciones';
import Dragger from 'components/Dragger';
import ModalDelete from 'components/ModalDelete';
import ModalConfirmation from 'components/ModalConfirmation';
import ExportadorExcelPersonalizado from 'components/ExportadorExcelPersonalizado';
import ReporteMovimientosModal from 'components/ReporteMovimientosModal';
import { FORMATO_MONEDA } from 'utils/excelReportes';
import { construirHojaCronologica } from 'utils/reporteCronologicoPlazas';
import AutorizacionPlazaDetalleModal from './AutorizacionPlazaDetalleModal';

export const administracionDePlazaPermission = {
  permissionModel: 'administraciondeplaza',
  catalogsModels: [],
  tabsModels: [],
};
const baseURI = 'catalogos/administracion-plazas-asignar-importar-excel';

//  CONFIGURACIÓN DEL SUJETO DE NÓMINA (Empleado / Becario / Honorario Asimilado)
// Único punto a extender si en el futuro se agrega un nuevo tipo de sujeto.
const SUJETO_EMPLEADO = 'empleado';
const SUJETO_BECARIO = 'becario';
const SUJETO_HONORARIO_ASIMILADO = 'honorarioasimilado';

const SUJETO_OPCIONES_FALLBACK = [
  { slug: SUJETO_EMPLEADO, etiqueta: 'Empleado' },
  { slug: SUJETO_BECARIO, etiqueta: 'Becario' },
  { slug: SUJETO_HONORARIO_ASIMILADO, etiqueta: 'Honorario Asimilado' },
];

// Datos del Nombramiento que se genera al Autorizar la Asignación (solo para
// sujeto Empleado) -- mismas opciones que "Agregar Nombramiento Masivo" en
// Nombramientos (ConsultasDeNombramientos.jsx).
const PERIODICIDAD_OPCIONES = [
  { value: 'quincenal', label: 'Quincenal (15 días)' },
  { value: 'mensual', label: 'Mensual' },
  { value: 'bimestral', label: 'Bimestral (2 meses)' },
  { value: 'trimestral', label: 'Trimestral (3 meses)' },
  { value: 'semestral', label: 'Semestral (6 meses)' },
  { value: 'anual', label: 'Anual (12 meses)' },
];

const PERIODICIDAD_MESES = {
  quincenal: null,
  mensual: 1,
  bimestral: 2,
  trimestral: 3,
  semestral: 6,
  anual: 12,
};

// Campo id (en la vista optimizada de asignación de plazas) que identifica al sujeto
const SUJETO_CAMPO_ID = {
  [SUJETO_EMPLEADO]: 'empleado_id',
  [SUJETO_BECARIO]: 'becario_id',
  [SUJETO_HONORARIO_ASIMILADO]: 'honorario_asimilado_id',
};
// Campo "Número y Nombre" a mostrar en la columna del listado
const SUJETO_CAMPO_NOMBRE = {
  [SUJETO_EMPLEADO]: 'numero_y_nombre_empleado',
  [SUJETO_BECARIO]: 'numero_y_nombre_becario',
  [SUJETO_HONORARIO_ASIMILADO]: 'numero_y_nombre_honorario_asimilado',
};
// Nombre del campo FK en AdministracionDePlaza / Form
const SUJETO_CAMPO_FORM = {
  [SUJETO_EMPLEADO]: 'empleado',
  [SUJETO_BECARIO]: 'becario',
  [SUJETO_HONORARIO_ASIMILADO]: 'honorario_asimilado',
};
const SUJETO_ETIQUETA = {
  [SUJETO_EMPLEADO]: 'Empleado',
  [SUJETO_BECARIO]: 'Becario',
  [SUJETO_HONORARIO_ASIMILADO]: 'Honorario Asimilado',
};
// Campo "numero_y_nombre" en el catálogo de personas disponibles (Select en modo alta)
const SUJETO_LABEL_PROP_CATALOGO = {
  [SUJETO_EMPLEADO]: 'numero_y_nombre_completo',
  [SUJETO_BECARIO]: 'becario_numero_y_nombre_completo',
  [SUJETO_HONORARIO_ASIMILADO]: 'honorario_asimilado_numero_y_nombre_completo',
};
// Campo "numero_y_nombre" en el detalle de AdministracionDePlaza (Select disabled en modo edición)
const SUJETO_LABEL_PROP_ADMIN_PLAZA = {
  [SUJETO_EMPLEADO]: 'empleado_numero_y_nombre_completo',
  [SUJETO_BECARIO]: 'becario_numero_y_nombre_completo',
  [SUJETO_HONORARIO_ASIMILADO]: 'honorario_asimilado_numero_y_nombre_completo',
};
// Catálogo de personas por sujeto (vista optimizada) y su dato operacional
const GET_PERSONAS_POR_SUJETO = {
  [SUJETO_EMPLEADO]: getEmpleadosOptimized,
  [SUJETO_BECARIO]: getBecarioVistaoptimizado,
  [SUJETO_HONORARIO_ASIMILADO]: getHonorarioAsimiladoVistaoptimizado,
};
const GET_DATO_OPERACIONAL_OPTIMIZADO_POR_SUJETO = {
  [SUJETO_EMPLEADO]: getDatoOperacionalPorEmpleadoOptimized,
  [SUJETO_BECARIO]: getDatoOperacionalPorBecarioOptimized,
  [SUJETO_HONORARIO_ASIMILADO]: getDatoOperacionalPorHonorarioAsimiladoOptimized,
};
// Catálogo de personas (vista optimizada, con campos ricos: antigüedad, estatus, etc.)
// usado para generar las plantillas de Excel de Asignación/Desasignación de Plazas.
const GET_PERSONAS_VISTA_OPTIMIZADA_POR_SUJETO = {
  [SUJETO_EMPLEADO]: getEmpleadosvistaOptimized,
  [SUJETO_BECARIO]: getBecarioVistaoptimizado,
  [SUJETO_HONORARIO_ASIMILADO]: getHonorarioAsimiladoVistaoptimizado,
};
// Campo "Número de <sujeto>" en el catálogo de personas (vista optimizada)
const SUJETO_CAMPO_NUMERO_CATALOGO = {
  [SUJETO_EMPLEADO]: 'numero_de_empleado',
  [SUJETO_BECARIO]: 'numero_de_becario',
  [SUJETO_HONORARIO_ASIMILADO]: 'numero_de_honorario_asimilado',
};
// Campo "Estatus" en el catálogo de personas (vista optimizada)
const SUJETO_CAMPO_ESTATUS_CATALOGO = {
  [SUJETO_EMPLEADO]: 'estado_del_empleado',
  [SUJETO_BECARIO]: 'estados_globales_descripcion',
  [SUJETO_HONORARIO_ASIMILADO]: 'estados_globales_descripcion',
};
// Campo "Número de <sujeto>" en asignacion-plazas-vista-optimized (administracion de plaza)
const SUJETO_CAMPO_NUMERO_ADMIN_PLAZA = {
  [SUJETO_EMPLEADO]: 'numero_de_empleado',
  [SUJETO_BECARIO]: 'numero_de_becario',
  [SUJETO_HONORARIO_ASIMILADO]: 'numero_de_honorario_asimilado',
};
const AdministracionDePlaza = ({ permission }) => {
  const [form] = Form.useForm();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [showReporteMovimientos, setShowReporteMovimientos] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [open, setVisible] = useState(false);
  const [visibleAlert, setVisibleAlert] = useState(false);
  const [visibleDelete, setVisibleDelete] = useState(false);
  const [visibleDeleteCancelada, setVisibleDeleteCancelada] = useState(false);
  const [fullData, setFullData] = useState([]); // Todos los datos del servidor (para búsquedas/modales)
  const [showExportador, setShowExportador] = useState(false);
  const [datosParaExportar, setDatosParaExportar] = useState([]);
  const [asignacionData, setAsignacionData] = useState([]);
  const [autorizacionData, setAutorizacionData] = useState([]);
  const [desasignacionData, setDesasignacionData] = useState([]);
  const [canceladasData, setCanceladasData] = useState([]);
  const [todosData, setTodosData] = useState([]);
  const [currentAutorizacionTableData, setCurrentAutorizacionTableData] = useState([]);

  const [estados, setEstados] = useState([]);
  const [empleados, setEmpleados] = useState([]);
  const [plazas, setPlazas] = useState();
  const [plazasFiltered, setPlazasFiltered] = useState([]);
  const [area, setArea] = useState();
  const [puesto, setPuesto] = useState();
  const [categoria, setCategoria] = useState('');
  const [datosOperacionales, setDatosOperacionales] = useState([]);
  const [, setDisableEmpleados] = useState(true);
  const [empleadosFiltered, setEmpleadosFiltered] = useState([]);

  const [motivosMovimiento, setMotivosMovimiento] = useState([]);
  const [tiposDeMovimientosDeEmpleados, setTiposDeMovimientosDeEmpleados] = useState([]);
  const [isBlocked, setIsBlocked] = useState(false);
  const [nominaDisplay, setNominaDisplay] = useState();
  const [tipoEmpleadoDisplay, setTipoEmpleadoDisplay] = useState();
  const [tipoEmpleadoPresupuestal, setTipoEmpleadoPresupuestal] = useState();
  const [tiposDeAsignacion, setTiposDeAsignacion] = useState([]);
  const [sueldoDiario, setSueldoDiario] = useState(0);
  const [sueldoMensual, setSueldoMensual] = useState(0);
  const [tiempoContratacion, setTiempoContratacion] = useState('');
  const [claseContratacion, setClaseContratacion] = useState('');
  const [empleadoNombre, setEmpleadoNombre] = useState('');
  const [isEditing, setIsEditing] = useState(false);
  // estados_globales (pk) del registro en edición, tal como lo devuelve el detalle
  // (getAdministracionDePlaza) -- no el campo `estado_global_id` de la vista
  // optimizada de la tabla, que no siempre se guarda en `selectedRowData` (p. ej.
  // en el tab Autorización, donde la selección de fila es multi-selección y no
  // pasa por `handleOnRowClick`/`setSelectedRowData`).
  const [registroEstadosGlobales, setRegistroEstadosGlobales] = useState(null);
  const [tiposDeActividad, setTiposDeActividad] = useState([]);
  const [caracteresDeNombramiento, setCaracteresDeNombramiento] = useState([]);
  const [visibleAutorizarMasivo, setVisibleAutorizarMasivo] = useState(false);
  const [visibleDetalle, setVisibleDetalle] = useState(false);
  const [observacionesMasivas, setObservacionesMasivas] = useState('');

  // Polling — autorización masiva en background
  const DESCRIPCION_PROCESO_AUTORIZACION = 'Autorizar Plaza Masiva';
  const [isPolling, setIsPolling] = useState(false);
  const [progresoActual, setProgresoActual] = useState({ en_curso: 0, total: 0 });
  const pollingRef = useRef(null);
  const [erroresAutorizacion, setErroresAutorizacion] = useState([]);
  const [modalErroresVisible, setModalErroresVisible] = useState(false);

  // Polling — importación Excel asignar en background
  const DESCRIPCION_PROCESO_IMPORTAR = 'Importar Plazas Asignar';
  const [isPollingImport, setIsPollingImport] = useState(false);
  const [progresoImport, setProgresoImport] = useState({ en_curso: 0, total: 0 });
  const pollingImportRef = useRef(null);

  // Polling — importación Excel desasignar en background
  const DESCRIPCION_PROCESO_DESASIGNAR = 'Importar Plazas Desasignar';
  const [isPollingDesasignar, setIsPollingDesasignar] = useState(false);
  const [progresoDesasignar, setProgresoDesasignar] = useState({ en_curso: 0, total: 0 });
  const pollingDesasignarRef = useRef(null);
  const [recordParaDetalle, setRecordParaDetalle] = useState(null);
  const [misLimitacionesIds, setMisLimitacionesIds] = useState([]);
  const [pasoAutorizacionPlaza, setPasoAutorizacionPlaza] = useState(null);
  const [visibleModal, setVisibleModal] = useState(false);
  const [formCarga] = Form.useForm();
  const [visibleModalDesasignar, setVisibleModalDesasignar] = useState(false);
  const [formCargaDesasignar] = Form.useForm();
  const [visibleCancelarDesasignacion, setVisibleCancelarDesasignacion] = useState(false);
  const [visibleCancelarAsignacion, setVisibleCancelarAsignacion] = useState(false);
  const [disableAsignacion, setDisableAsignacion] = useState(false);
  const [periodosNombramiento, setPeriodosNombramiento] = useState([]);
  const [periodosFiscales, setPeriodosFiscales] = useState([]);
  const [periodosDeNominaDetalle, setPeriodosDeNominaDetalle] = useState([]);
  const [tipoNominaEmpleadoPlaza, setTipoNominaEmpleadoPlaza] = useState(null);
  const [tiposDeMovimientoDePersonal, setTiposDeMovimientoDePersonal] = useState([]);

  //  SUJETO DE NÓMINA (Empleado / Becario / Honorario Asimilado)
  const [sujeto, setSujeto] = useState(SUJETO_EMPLEADO);
  const [sujetosDeNomina, setSujetosDeNomina] = useState(SUJETO_OPCIONES_FALLBACK);

  // names
  const nameEmpleado = SUJETO_CAMPO_FORM[sujeto];
  const nameAlta = 'fecha_alta';
  const nameInicioVigencia = 'fecha_inicio_asignacion';

  const GET_DATO_OPERACIONAL_POR_SUJETO = {
    [SUJETO_EMPLEADO]: getDatoOperacionalPorEmpleado,
    [SUJETO_BECARIO]: getDatoOperacionalPorBecario,
    [SUJETO_HONORARIO_ASIMILADO]: getDatoOperacionalPorHonorarioAsimilado,
  };

  const watcherEmpleado = Form.useWatch(nameEmpleado, form);
  useEffect(() => {
    const obtenerEmpleado = async (_empleado) => {
      const obtenerDatoOperacional = GET_DATO_OPERACIONAL_POR_SUJETO[sujeto];
      const empleadoRegistro = await obtenerDatoOperacional(_empleado);
      let fecha = empleadoRegistro.fecha_de_reingreso ?? null;
      fecha = empleadoRegistro.fecha_de_alta ?? null;
      if (fecha != null) {
        form.setFieldValue(nameInicioVigencia, moment(fecha));
      }
      setDisableAsignacion(fecha);
    };
    // Al editar un registro existente, fecha_inicio_asignacion ya viene del snapshot
    // congelado en AdministracionDePlaza (ver onClickEdit) -- no sobreescribirlo con
    // el dato operacional EN VIVO del empleado, que no representa el histórico.
    if (watcherEmpleado && !isEditing) {
      obtenerEmpleado(watcherEmpleado);
    }
  }, [watcherEmpleado, isEditing]);

  //  CONFIGURACIÓN DE PESTAÑAS
  const TAB_ASIGNACION = 'asignacion';
  const TAB_AUTORIZACION = 'autorizacion';
  const TAB_DESASIGNACION = 'desasignacion';
  const TAB_CANCELADAS = 'canceladas';
  const TAB_TODOS = 'todos';
  // La pantalla abre en "Todos" (primer tab).
  const [activeTab, setActiveTab] = useState(TAB_TODOS);

  const formatReceivedClone = (values) => {
    if (Array.isArray(values)) {
      const valueClone = values.map((e) => formatReceivedValues(e));
      return valueClone;
    }
    return formatReceivedValues(values);
  };

  const formInstances = [form];
  // Usamos solo el endpoint optimizado para traer todo
  const optimizedURI = '/catalogos/asignacion-plazas-vista-optimized';

  //  CARGA DE CATÁLOGOS
  useEffect(() => {
    const loadCatalogs = async () => {
      try {
        const [
          motivos,
          estadosData,
          tiposAct,
          tiposAsig,
          tiposMovimiento,
          sujetosData,
          caracteresNombramiento,
          periodosFiscalesData,
          tiposMovPersonal,
        ] = await Promise.all([
          getMotivosDeMovimientosDeEmpleados(),
          getEstadosPlazas(),
          getTiposDeActividades(),
          getTiposAsignacion(),
          getTiposDeMovimientosDeEmpleados(),
          getSujetosDeNomina(),
          getCaracteresDeNombramiento(),
          getPeriodosFiscales({ estados_globales: 4 }),
          getTiposDeMovimientoDePersonal({ estados_globales: ESTATUS_AUTORIZADO, modelo_origen: 'ASIGNACION_PLAZA' }),
        ]);
        setMotivosMovimiento(motivos);
        setEstados(estadosData);
        setTiposDeActividad(tiposAct);
        setTiposDeAsignacion(tiposAsig);
        setTiposDeMovimientosDeEmpleados(tiposMovimiento);
        setCaracteresDeNombramiento(caracteresNombramiento);
        setPeriodosFiscales(periodosFiscalesData);
        setTiposDeMovimientoDePersonal(Array.isArray(tiposMovPersonal) ? tiposMovPersonal : tiposMovPersonal?.results || []);
        if (Array.isArray(sujetosData) && sujetosData.length) {
          setSujetosDeNomina(sujetosData);
        }
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error('[Administración de Plazas] error al cargar catálogos', err);
      }
    };
    loadCatalogs();
  }, []);

  //  1. FETCH DE DATOS COMPLETOS
  const fetchFullData = async () => {
    setLoading(true);
    try {
      const response = await API.get(optimizedURI);
      const rawData = response.data?.results || response.data || [];
      const allRecords = formatReceivedClone(rawData);

      setFullData(allRecords); // Guardamos todo en memoria
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  // Filtra fullData por sujeto seleccionado y en los 3 tabs (cliente, sin peticiones extra)
  useEffect(() => {
    if (!fullData.length) return;
    const campoIdSujeto = SUJETO_CAMPO_ID[sujeto];
    const dataDelSujeto = fullData.filter((r) => r[campoIdSujeto] != null);
    setAsignacionData(dataDelSujeto.filter((r) => r.estado_global_id === 4));
    const autData = dataDelSujeto.filter((r) => r.estado_global_id === 1);
    setAutorizacionData(autData);
    setCurrentAutorizacionTableData(autData); // reset al recargar datos
    setDesasignacionData(dataDelSujeto.filter((r) => r.estado_global_id === 3));
    setCanceladasData(dataDelSujeto.filter((r) => r.estado_global_id === 5));
    // "Todos": Activas, Autorizadas, Desasignadas y Canceladas del sujeto actual.
    setTodosData(dataDelSujeto);
  }, [fullData, sujeto]);

  // Refresca todo (usar en mutaciones)
  const refreshData = fetchFullData;

  // Dataset efectivo del tab Autorización: prioriza el filtrado de la tabla si lo hay.
  const autorizacionEffectiveData = currentAutorizacionTableData.length
    ? currentAutorizacionTableData
    : autorizacionData;

  const handleAutorizacionTableChange = (_p, _f, _s, extra) => {
    if (extra?.currentDataSource) {
      setCurrentAutorizacionTableData(extra.currentDataSource);
    }
  };

  const handleAutorizacionMultiSelect = () => {
    setSelectedRowKeys([...new Set(autorizacionEffectiveData.map((r) => r.id))]);
  };

  const handleAutorizacionMultiDeselect = () => {
    setSelectedRowKeys([]);
  };

  useEffect(() => {
    fetchFullData();
  }, []);

  // Limpiar selección al cambiar de tab o de sujeto de nómina
  useEffect(() => {
    setSelectedRowKeys([]);
  }, [activeTab, sujeto]);

  // Polling — autorización masiva en background (cada 2s, máx ~11 min)
  useEffect(() => {
    if (!isPolling) return () => {};

    let intentos = 0;
    const maxIntentos = 340;

    pollingRef.current = setInterval(async () => {
      try {
        intentos += 1;
        const lista = await getProcesoEnCursoTerminado({
          descripcion: DESCRIPCION_PROCESO_AUTORIZACION,
        });
        const proceso = lista[0];

        if (proceso) {
          setProgresoActual({
            en_curso: proceso.registro_en_curso || 0,
            total: proceso.total_registros || 0,
          });
        }

        const termino = proceso && proceso.procesando === false;
        if (termino || intentos >= maxIntentos) {
          clearInterval(pollingRef.current);
          pollingRef.current = null;
          setIsPolling(false);
          setProgresoActual({ en_curso: 0, total: 0 });
          setSelectedRowKeys([]);
          refreshData();

          let errores = [];
          if (proceso?.resultado) {
            try {
              const parsed = JSON.parse(proceso.resultado);
              if (parsed.errores && parsed.errores.length > 0) {
                errores = parsed.errores;
              }
            } catch (_) { /* resultado no es JSON (p.ej. base64) — ignorar */ }
          }

          if (errores.length > 0) {
            setErroresAutorizacion(errores);
            setModalErroresVisible(true);
            notification.warning({
              message: 'Autorización completada con errores',
              description: `${errores.length} plaza(s) no pudieron autorizarse. Revise el detalle.`,
              placement: 'topRight',
              duration: 8,
            });
          } else {
            notification.success({
              message: 'Autorización completada',
              description: 'La autorización masiva de plazas finalizó correctamente.',
              placement: 'topRight',
              duration: 6,
            });
          }
        }
      } catch (_err) {
        // No se interrumpe el polling: el siguiente tick reintenta. Si el
        // error es por sesión expirada, utils/api.js ya avisó y cerró
        // sesión; aquí solo dejamos rastro para diagnóstico.
        // eslint-disable-next-line no-console
        console.error('[polling autorización masiva de plazas] error al consultar estado', _err);
      }
    }, 2000);

    return () => {
      if (pollingRef.current) {
        clearInterval(pollingRef.current);
        pollingRef.current = null;
      }
    };
  }, [isPolling]);

  // Polling — importación Excel en background (cada 2s, máx ~11 min)
  useEffect(() => {
    if (!isPollingImport) return () => {};

    let intentos = 0;
    const maxIntentos = 340;

    pollingImportRef.current = setInterval(async () => {
      try {
        intentos += 1;
        const lista = await getProcesoEnCursoTerminado({
          descripcion: DESCRIPCION_PROCESO_IMPORTAR,
        });
        const proceso = lista[0];

        if (proceso) {
          setProgresoImport({
            en_curso: proceso.registro_en_curso || 0,
            total: proceso.total_registros || 0,
          });
        }

        const termino = proceso && proceso.procesando === false;
        if (termino || intentos >= maxIntentos) {
          clearInterval(pollingImportRef.current);
          pollingImportRef.current = null;
          setIsPollingImport(false);
          setProgresoImport({ en_curso: 0, total: 0 });

          // Descargar el Excel de resultado si existe en proceso.resultado (base64)
          if (proceso?.resultado) {
            const byteCharacters = atob(proceso.resultado);
            const byteArray = new Uint8Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i += 1) {
              byteArray[i] = byteCharacters.charCodeAt(i);
            }
            const blob = new Blob([byteArray], {
              type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            });
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = 'Asignacion de Plaza (Asignar).xlsx';
            link.click();
            URL.revokeObjectURL(url);
          }

          notification.success({
            message: 'Importación completada',
            description: 'La carga masiva de plazas finalizó. Se descargó el archivo de resultado.',
            placement: 'topRight',
            duration: 6,
          });
          refreshData();
        }
      } catch (_err) {
        // No se interrumpe el polling: el siguiente tick reintenta. Si el
        // error es por sesión expirada, utils/api.js ya avisó y cerró
        // sesión; aquí solo dejamos rastro para diagnóstico.
        // eslint-disable-next-line no-console
        console.error('[polling importación Excel asignar plazas] error al consultar estado', _err);
      }
    }, 2000);

    return () => {
      if (pollingImportRef.current) {
        clearInterval(pollingImportRef.current);
        pollingImportRef.current = null;
      }
    };
  }, [isPollingImport]);

  // Polling — importación Excel desasignar en background (cada 2s, máx ~11 min)
  useEffect(() => {
    if (!isPollingDesasignar) return () => {};

    let intentos = 0;
    const maxIntentos = 340;

    pollingDesasignarRef.current = setInterval(async () => {
      try {
        intentos += 1;
        const lista = await getProcesoEnCursoTerminado({
          descripcion: DESCRIPCION_PROCESO_DESASIGNAR,
        });
        const proceso = lista[0];

        if (proceso) {
          setProgresoDesasignar({
            en_curso: proceso.registro_en_curso || 0,
            total: proceso.total_registros || 0,
          });
        }

        const termino = proceso && proceso.procesando === false;
        if (termino || intentos >= maxIntentos) {
          clearInterval(pollingDesasignarRef.current);
          pollingDesasignarRef.current = null;
          setIsPollingDesasignar(false);
          setProgresoDesasignar({ en_curso: 0, total: 0 });

          if (proceso?.resultado) {
            const byteCharacters = atob(proceso.resultado);
            const byteArray = new Uint8Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i += 1) {
              byteArray[i] = byteCharacters.charCodeAt(i);
            }
            const blob = new Blob([byteArray], {
              type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            });
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = 'Asignacion de Plaza (Desasignar).xlsx';
            link.click();
            URL.revokeObjectURL(url);
          }

          notification.success({
            message: 'Desasignación completada',
            description: 'La carga masiva de desasignaciones finalizó. Se descargó el archivo de resultado.',
            placement: 'topRight',
            duration: 6,
          });
          refreshData();
        }
      } catch (_err) {
        // No se interrumpe el polling: el siguiente tick reintenta. Si el
        // error es por sesión expirada, utils/api.js ya avisó y cerró
        // sesión; aquí solo dejamos rastro para diagnóstico.
        // eslint-disable-next-line no-console
        console.error('[polling importación Excel desasignar plazas] error al consultar estado', _err);
      }
    }, 2000);

    return () => {
      if (pollingDesasignarRef.current) {
        clearInterval(pollingDesasignarRef.current);
        pollingDesasignarRef.current = null;
      }
    };
  }, [isPollingDesasignar]);

  //  CARGA DE IDENTIDAD DEL USUARIO (SEGURIDAD)
  useEffect(() => {
    const loadUserPermissions = async () => {
      try {
        const limData = await getUsuariosLimitaciones();
        const currentUserId = selectUser(store.getState())?.id;

        const allLimitaciones = limData.results || limData || [];

        // Filtramos: ¿Qué IDs de limitación (niveles) me pertenecen a mí?
        const misPermisos = allLimitaciones
          .filter((l) => l.usuario === currentUserId)
          .map((l) => l.id);

        setMisLimitacionesIds(misPermisos);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('[Administración de Plazas] error al cargar las limitaciones de autorización del usuario', error);
      }
    };
    loadUserPermissions();

    obtenerMiPasoDeAutorizacion(getLimitacionesAdministracionPlazas)
      .then(setPasoAutorizacionPlaza);
  }, []);

  const requiereObservacionesPlaza = !!pasoAutorizacionPlaza?.requiere_observaciones;

  //  FUNCIONES AUXILIARES
  const loadEmpleadosFiltered = () => {
    const plazaDispIds = plazasFiltered.map((p) => p.id);
    const empConPlazaDisp = datosOperacionales
      .filter((d) => plazaDispIds.includes(d.plaza))
      .map((d) => d.empleado);

    // Usamos fullData para verificar asignados
    const empAsignados = new Set(fullData.map((x) => x.empleado));

    const disponibles = empleados.filter((e) => empConPlazaDisp.includes(e.id)
      && !empAsignados.has(e.id));
    setEmpleadosFiltered(disponibles);
  };

  const onChangePlaza = (plazaId) => {
    const plazaSeleccionada = plazasFiltered.find((p) => p.id === plazaId);
    if (plazaSeleccionada) {
      setArea(plazaSeleccionada.directorio_area_clave_y_nombre?.trim());
      setPuesto(plazaSeleccionada.clave_y_descripcion?.split(' - ')[1] || plazaSeleccionada.puesto);
      setCategoria(plazaSeleccionada.categoria_de_empleado);
      setNominaDisplay(plazaSeleccionada.tipo_nomina_empleado);
      setTipoEmpleadoDisplay(plazaSeleccionada.tipo_de_empleado);
      setTipoEmpleadoPresupuestal(plazaSeleccionada.tipo_de_empleado_presupuestal);
      setSueldoDiario(parseFloat(plazaSeleccionada.sueldo_diario_nominal_asignado || 0));
      setSueldoMensual(parseFloat(plazaSeleccionada.sueldo_mensual_nominal_asignado || 0));
      setTipoNominaEmpleadoPlaza(plazaSeleccionada.tipo_nomina_empleado_id || null);
    } else {
      setTipoNominaEmpleadoPlaza(null);
    }
    form.setFieldsValue({
      periodo_fiscal_retroactivo: undefined,
      periodo_de_pago_retroactivo: undefined,
    });
    setPeriodosDeNominaDetalle([]);
  };

  const onChangeTipoNominaEmpleado = (val) => {
    form.resetFields([nameEmpleado]);
    setSueldoDiario(0);
    setSueldoMensual(0);
    if (val) {
      setDisableEmpleados(false);
      loadEmpleadosFiltered();
    } else {
      setDisableEmpleados(true);
    }
  };

  const onChangeEmpleado = (val) => {
    if (val) {
      // Buscamos en fullData (memoria)
      const campoIdSujeto = SUJETO_CAMPO_ID[sujeto];
      const _adminRecord = fullData.find((e) => e[campoIdSujeto] === val);
      if (_adminRecord) {
        setSueldoDiario(_adminRecord.sueldo_diario_nominal_asignado);
        setSueldoMensual(_adminRecord.sueldo_mensual_nominal_asignado);
        setNominaDisplay(_adminRecord.tipo_de_nomina_empleado_descripcion);
      }
    } else {
      setSueldoDiario(0);
      setSueldoMensual(0);
      setNominaDisplay(undefined);
    }
  };

  const onCancel = () => {
    setSelectedRowKeys([]);
    setVisibleAlert(false);
    setVisible(false);
    setCategoria(); setPuesto(); setArea();
    setSueldoDiario(0); setSueldoMensual(0);
    setDisableEmpleados(true);
    setNominaDisplay();
    setTipoEmpleadoDisplay();
    setTipoEmpleadoPresupuestal();
    setTipoNominaEmpleadoPlaza(null);
    form.resetFields();
    setIsEditing(false);
    setRegistroEstadosGlobales(null);
    setPeriodosNombramiento([]);
    setPeriodosDeNominaDetalle([]);
  };

  const generarPeriodosNombramiento = (inicioVigencia, terminoVigencia, periodicidad) => {
    if (!inicioVigencia || !terminoVigencia || !periodicidad) return [];
    const inicio = moment(inicioVigencia);
    const fin = moment(terminoVigencia);
    if (!inicio.isValid() || !fin.isValid() || fin.isBefore(inicio)) return [];

    const resultado = [];
    let current = inicio.clone();
    let idx = 0;

    while (current.isSameOrBefore(fin, 'day')) {
      let periodoFin;
      let siguiente;
      if (periodicidad === 'quincenal') {
        if (current.date() <= 15) {
          const quincenaFin = current.clone().date(15);
          periodoFin = quincenaFin.isAfter(fin) ? fin.clone() : quincenaFin;
          siguiente = current.clone().date(16);
        } else {
          const quincenaFin = current.clone().endOf('month').startOf('day');
          periodoFin = quincenaFin.isAfter(fin) ? fin.clone() : quincenaFin;
          siguiente = current.clone().add(1, 'month').date(1);
        }
      } else {
        const meses = PERIODICIDAD_MESES[periodicidad];
        const candidato = current.clone().add(meses, 'month').subtract(1, 'day');
        periodoFin = candidato.isAfter(fin) ? fin.clone() : candidato;
        siguiente = current.clone().add(meses, 'month');
      }
      resultado.push({
        key: idx,
        inicio: current.format('YYYY-MM-DD'),
        fin: periodoFin.format('YYYY-MM-DD'),
      });
      idx += 1;
      current = siguiente;
    }
    return resultado;
  };

  const recalcularPeriodosNombramiento = () => {
    const values = form.getFieldsValue();
    const inicio = values.inicio_vigencia_nombramiento;
    const termino = values.termino_vigencia_nombramiento;
    const periodicidad = values.periodicidad_nombramiento;
    if (inicio && termino && periodicidad) {
      const generados = generarPeriodosNombramiento(
        inicio.format('YYYY-MM-DD'),
        termino.format('YYYY-MM-DD'),
        periodicidad,
      );
      setPeriodosNombramiento(generados);
    } else {
      setPeriodosNombramiento([]);
    }
  };

  const fetchPeriodosDetalleRetroactivo = async (periodoFiscalId, tipoNominaEmpleadoId) => {
    setPeriodosDeNominaDetalle([]);
    if (!periodoFiscalId || !tipoNominaEmpleadoId) return;
    try {
      const data = await getPeriodosDeNominasDetalles({
        periodo_de_nomina__periodo_fiscal: periodoFiscalId,
        periodo_de_nomina__tipo_de_nomina_empleado: tipoNominaEmpleadoId,
        estados_globales: 4,
      });
      setPeriodosDeNominaDetalle(data);
    } catch { /* ignore */ }
  };

  const onChangePeriodoFiscalRetroactivo = async (periodoFiscalId) => {
    form.setFieldsValue({ periodo_de_pago_retroactivo: undefined });
    await fetchPeriodosDetalleRetroactivo(periodoFiscalId, tipoNominaEmpleadoPlaza);
  };

  const onClickEdit = async () => {
    const [key] = selectedRowKeys;
    if (!key) return;
    setLoading(true);
    // Obtenemos detalle para edición
    const _adminPlaza = await getAdministracionDePlaza(key);
    const _plaza = await getPlazavistaOptimized(_adminPlaza?.plaza);

    // El <Select> de "Número Clave Plaza" muestra clave_y_descripcion de este objeto.
    // Al editar un registro ya existente debe mostrar el snapshot histórico congelado
    // en AdministracionDePlaza (plaza_clave_y_descripcion), no el estado EN VIVO de la
    // Plaza -- que puede haber sido reasignada a otro Puesto desde entonces.
    const _plazaConSnapshot = {
      ..._plaza,
      clave_y_descripcion: _adminPlaza?.plaza_clave_y_descripcion || _plaza.clave_y_descripcion,
    };

    setPlazasFiltered((prev) => {
      const existe = prev.some((p) => p.id === _plazaConSnapshot.id);
      return existe ? prev : [...prev, _plazaConSnapshot];
    });

    const campoFormSujeto = SUJETO_CAMPO_FORM[sujeto];
    form.resetFields();
    form.setFieldsValue({
      ...formatReceivedClone(_adminPlaza),
      [campoFormSujeto]: _adminPlaza[campoFormSujeto],
    });
    setEmpleadoNombre([{
      ..._adminPlaza,
      id: _adminPlaza[campoFormSujeto],
    }]);
    setTiempoContratacion(_plaza.tiempo_de_contratacion);
    setClaseContratacion(_plaza.clase_de_contratacion);
    setArea(_adminPlaza.directorio_de_area_clave_y_nombre);
    setPuesto(_adminPlaza.puesto_descripcion);
    setCategoria(_adminPlaza.categoria_nombre);
    setSueldoDiario(parseFloat(_adminPlaza.sueldo_diario_nominal_asignado));
    setSueldoMensual(parseFloat(_adminPlaza.sueldo_mensual_nominal_asignado));
    setNominaDisplay(_adminPlaza.tipo_de_nomina_empleado_descripcion);
    setTipoEmpleadoDisplay(_adminPlaza.tipo_empleado_descripcion);
    setTipoEmpleadoPresupuestal(_adminPlaza.tipo_de_empleado_presupuestal_descripcion);
    setPlazas(plazasFiltered);

    const tneId = _adminPlaza.tipo_de_nomina_empleado || _plaza?.tipo_nomina_empleado_id || null;
    setTipoNominaEmpleadoPlaza(tneId);

    setDisableEmpleados(true);
    setIsEditing(true);
    setRegistroEstadosGlobales(_adminPlaza.estados_globales);
    setVisible(true);
    setLoading(false);

    if (_adminPlaza.periodicidad_nombramiento
      && _adminPlaza.inicio_vigencia_nombramiento
      && _adminPlaza.termino_vigencia_nombramiento) {
      const generados = generarPeriodosNombramiento(
        _adminPlaza.inicio_vigencia_nombramiento,
        _adminPlaza.termino_vigencia_nombramiento,
        _adminPlaza.periodicidad_nombramiento,
      );
      setPeriodosNombramiento(generados);
    } else {
      setPeriodosNombramiento([]);
    }

    if (_adminPlaza.periodo_fiscal_retroactivo) {
      await fetchPeriodosDetalleRetroactivo(_adminPlaza.periodo_fiscal_retroactivo, tneId);
    } else {
      setPeriodosDeNominaDetalle([]);
    }
  };

  const onFinish = async (_values, _continue = false) => {
    try {
      setLoading(true);
      await form.validateFields();
      const values = { ...form.getFieldsValue() };
      const selectedPlaza = plazas.find((p) => p.id === values.plaza);
      values.tipo_empleado = selectedPlaza?.tipo_de_empleado_id;
      values.sueldo_diario = sueldoDiario;
      if (!values.aplica_retroactivo) {
        values.periodo_fiscal_retroactivo = null;
        values.periodo_de_pago_retroactivo = null;
      }

      const plazaKey = values.plaza;
      const [key] = selectedRowKeys;

      const saved = await (key
        ? patchAdministracionDePlaza(key, values)
        : postAdministracionDePlaza(values));

      if (saved) {
        await patchPlaza(plazaKey, { estado_plaza: 5 }); // 5 = Asignada
        if (_continue) {
          await refreshData();
          setSelectedRowKeys([saved.id]);
          onClickEdit(saved);
        } else {
          onCancel();
          await refreshData();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading, formInstances);
    }
  };

  const onUnasign = async () => {
    try {
      setLoading(true);
      if (selectedRowKeys.length) {
        const [key] = selectedRowKeys;
        // Solo se validan los campos del modal "Desasignar Plaza" (ModalUnAsignPlaza).
        // `form` es la misma instancia que usa el formulario de Agregar/Editar Asignación
        // (Motivo de Asignación de Plaza, datos del Nombramiento, etc.) -- validar sin
        // nameList (form.validateFields()) arrastra también esos campos, que no aplican
        // ni se capturan al desasignar.
        const esBaja = form.getFieldValue('es_baja');
        const fieldsToValidate = ['es_baja', esBaja ? 'fecha_baja' : 'fecha_desasignacion', 'motivo_desasignacion'];
        if (esBaja) {
          fieldsToValidate.push('aplica_liquidacion');
          if (form.getFieldValue('aplica_liquidacion')) {
            fieldsToValidate.push('liquidacion');
          }
        }
        await form.validateFields(fieldsToValidate);
        const oldValues = await getAdministracionDePlaza(key);
        const newValues = form.getFieldsValue();
        const values = { ...formatReceived(oldValues), ...newValues };
        delete values.origen_recurso_nomina;
        values.estados_globales = 3;

        const saved = await patchAdministracionDePlaza(key, values);
        if (saved) {
          // const deleted = await deleteAdministracionDePlaza(key);
          // if (deleted) {
          //   await patchPlaza(selectedRowData?.plaza, { estado_plaza: ESTADO_PLAZA_DISPONIBLE });
          //   setVisibleAlert(false);
          //   onCancel();
          //   await fetchFullData(); // Recargar todo para actualizar las listas
          // }
          setVisibleAlert(false);
          onCancel();
          await refreshData();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  // Cancela un registro ya Desasignado: la Plaza asociada vuelve a Disponible (backend)
  const onCancelarDesasignacion = async () => {
    try {
      setLoading(true);
      const [key] = selectedRowKeys;
      if (key) {
        const oldValues = await getAdministracionDePlaza(key);
        const values = { ...formatReceived(oldValues) };
        delete values.origen_recurso_nomina;
        values.estados_globales = 5; // 5 = Cancelado
        const saved = await patchAdministracionDePlaza(key, values);
        if (saved) {
          setSelectedRowKeys([]);
          setVisibleCancelarDesasignacion(false);
          await refreshData();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const onConfirmCancelarDesasignacion = () => {
    setVisibleCancelarDesasignacion(true);
  };

  // Cancela una Asignación activa (Autorizada): la Plaza asociada vuelve a Disponible (backend)
  const onCancelarAsignacion = async () => {
    try {
      setLoading(true);
      const [key] = selectedRowKeys;
      if (key) {
        const oldValues = await getAdministracionDePlaza(key);
        const values = { ...formatReceived(oldValues) };
        delete values.origen_recurso_nomina;
        values.estados_globales = 5; // 5 = Cancelado
        const saved = await patchAdministracionDePlaza(key, values);
        if (saved) {
          setSelectedRowKeys([]);
          setVisibleCancelarAsignacion(false);
          await refreshData();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const onConfirmCancelarAsignacion = () => {
    setVisibleCancelarAsignacion(true);
  };

  const handleOnRowClick = (record) => {
    // LÓGICA PARA PESTAÑA AUTORIZACIÓN (Múltiple / Checkbox)
    if (activeTab === TAB_AUTORIZACION) {
      const isSelected = selectedRowKeys.includes(record.id);
      let newKeys = [];

      if (isSelected) {
        // Si ya estaba, lo quitamos del array (Deseleccionar)
        newKeys = selectedRowKeys.filter((key) => key !== record.id);
      } else {
        newKeys = [...selectedRowKeys, record.id];
      }
      setSelectedRowKeys(newKeys);
    } else {
      setSelectedRowKeys([record.id]);
      setSelectedRowData(record);
      setNominaDisplay(record.tipo_de_nomina_empleado_descripcion);
      setIsBlocked(false);
      form.setFieldsValue(record);
    }
  };
  const rowSelection = {
    selectedRowKeys,
    type: 'radio',
  };

  const onClickAdd = async () => {
    form.resetFields();
    form.setFieldsValue({ fecha_alta: moment() });
    try {
      setLoading(true);
      const campoIdSujeto = SUJETO_CAMPO_ID[sujeto];
      const obtenerPersonas = GET_PERSONAS_POR_SUJETO[sujeto];
      const obtenerDatosOperacionalesOptimizados = GET_DATO_OPERACIONAL_OPTIMIZADO_POR_SUJETO[sujeto];
      const [plazasResp, personasResp, operResp] = await Promise.all([
        getPlazasvistaOptimized({ sujeto }),
        obtenerPersonas(),
        obtenerDatosOperacionalesOptimizados(),
      ]);

      const plazasList = plazasResp?.results || plazasResp || [];
      const personasList = personasResp?.results || personasResp || [];
      const operacionalesList = Array?.isArray(operResp) ? operResp : (operResp?.results || []);

      const plazasParaAsignar = plazasList?.filter((p) => {
        const estatusId = Number(p?.estado_plaza_id);
        return estatusId === ESTADO_PLAZA_AUTORIZADA || estatusId === ESTADO_PLAZA_DISPONIBLE;
      });

      // Una persona ya tiene plaza solo si su dato operacional lo indica explícitamente;
      // si aún no existe un dato operacional para ella (común en Becario/Honorario Asimilado,
      // a diferencia de Empleado) se considera disponible por defecto.
      const idsConPlaza = new Set(
        operacionalesList
          .filter((d) => d?.plaza_id != null && d?.[campoIdSujeto] != null)
          .map((d) => d?.[campoIdSujeto]),
      );

      const personasSinPlaza = personasList?.filter((e) => !idsConPlaza?.has(e.id));

      setPlazas(plazasList);
      setPlazasFiltered(plazasParaAsignar); // <-- Pasamos la lista filtrada correctamente
      setEmpleados(personasList);
      setDatosOperacionales(operacionalesList);
      setEmpleadosFiltered(personasSinPlaza);
      setSelectedRowKeys([]);
      setVisible(true);
    } catch (err) {
      onError(err, setLoading);
    } finally {
      setLoading(false);
    }
  };

  // Exporta los registros de la pestaña (`datosDelTab`, ya filtrados por sujeto). Ya traen
  // los campos de Plaza congelados en cada Asignación (endpoint asignacion-plazas-vista-optimized).
  const onClickExcelCompleto = (datosDelTab) => {
    if (!datosDelTab?.length) {
      message.warning('No hay datos para exportar');
      return;
    }
    setDatosParaExportar(datosDelTab);
    setShowExportador(true);
  };

  const seguimiento = useSeguimientoDeRegistro({
    contentTypeAppLabel: 'catalogos',
    contentTypeModel: 'administraciondeplaza',
    moduloDescripcion: 'Nómina',
    documentoOperativoDescripcion: 'Asignación de Plazas',
    moduloOrigenLabel: 'Asignación de Plazas',
    registros: fullData,
    seleccionIds: selectedRowKeys,
    registroActivo: open && selectedRowKeys.length
      ? fullData.find((e) => e.id === selectedRowKeys[0]) || { id: selectedRowKeys[0] }
      : null,
    mutable: true,
    getRegistroLabel: (row) => `Asignación de Plaza ${row.id}`,
  });

  const columns = [
    {
      titleText: 'Fecha de Registro',
      dataIndex: 'fecha_alta',
      key: 'fecha_alta',
      width: 150,
      render: (val) => (val ? moment(val).format('DD/MM/YYYY') : ''),
    },
    {
      titleText: 'Fecha de Asignación',
      dataIndex: 'fecha_asignacion',
      key: 'fecha_asignacion',
      width: 150,
      render: (val) => (val ? moment(val).format('DD/MM/YYYY') : ''),
    },
    {
      titleText: 'Fecha de Baja',
      dataIndex: 'fecha_baja',
      key: 'fecha_baja',
      width: 150,
      render: (val) => (val ? moment(val).format('DD/MM/YYYY') : ''),
    },
    {
      titleText: 'Fecha de Desasignación',
      dataIndex: 'fecha_desasignacion',
      key: 'fecha_desasignacion',
      width: 150,
      render: (val) => (val ? moment(val).format('DD/MM/YYYY') : ''),
    },
    {
      titleText: `Número y Nombre del ${SUJETO_ETIQUETA[sujeto]}`,
      dataIndex: SUJETO_CAMPO_NOMBRE[sujeto],
      key: SUJETO_CAMPO_NOMBRE[sujeto],
      width: 350,
    },
    {
      titleText: 'Plaza',
      dataIndex: 'plaza_clave_y_descripcion',
      key: 'plaza_clave_y_descripcion',
      width: 150,
    },
    {
      titleText: 'Área',
      dataIndex: 'directorio_area_clave_y_nombre',
      key: 'directorio_area_clave_y_nombre',
      width: 200,
    },
    {
      titleText: 'Puesto',
      dataIndex: 'puesto_clave_y_descripcion',
      key: 'puesto_clave_y_descripcion',
      width: 200,
    },
    {
      titleText: 'Sueldo Diario',
      dataIndex: 'sueldo_diario_nominal_asignado',
      key: 'sueldo_diario_nominal_asignado',
      width: 150,
      render: (value) => currencyFormatter(value),
    },
    {
      titleText: 'Sueldo Mensual',
      dataIndex: 'sueldo_mensual_nominal_asignado',
      key: 'sueldo_mensual_nominal_asignado',
      width: 150,
      render: (value) => currencyFormatter(value),
    },
    {
      titleText: 'SBC',
      dataIndex: 'salario_base_cotizacion_imss',
      key: 'salario_base_cotizacion_imss',
      width: 150,
      render: (value) => currencyFormatter(value),
    },
    {
      titleText: 'Estatus',
      dataIndex: 'estado_global_descripcion',
      key: 'estado_global_descripcion',
      width: 150,
      // Tag de color por estatus (mismo criterio que Plazas / Registro de
      // Incidencias). Se decide por el texto porque el Table a veces llama a
      // render sin el registro (ordenamiento); el children sigue siendo el
      // texto, así que filtro y orden funcionan igual que antes.
      render: (descripcion) => {
        if (!descripcion) return null;
        const upper = String(descripcion).toUpperCase();
        let color = 'blue';
        if (upper.includes('AUTORIZ')) color = 'green';
        if (upper.includes('INACTIV') || upper.includes('DESASIG')) color = 'orange';
        if (upper.includes('CANCEL')) color = 'red';
        return <Tag color={color}>{descripcion}</Tag>;
      },
    },
  ];

  const onClickDelete = () => {
    setVisibleDelete(true);
  };

  const onClickDeleteCancelada = () => {
    setVisibleDeleteCancelada(true);
  };

  const requiredRule = { required: true, message: 'El campo es requerido' };
  const rules = {
    required: [requiredRule],
    clave: [{ required: true, pattern: SLUG_PATTERN, message: 'Ingrese una clave válida' }],
    startDate: [{ required: true }],
    endDate: [{ required: false }],
  };
  //  FUNCIÓN: Abrir modal de detalle
  const handleClickVerDetalle = () => {
    // Tomamos el primer ID seleccionado
    const [key] = selectedRowKeys;
    const record = fullData.find((r) => r.id === key);
    setRecordParaDetalle(record);
    setVisibleDetalle(true);
  };

  const ModalForDelete = () => {
    const deleteItem = async () => {
      try {
        setLoading(true);
        if (selectedRowKeys.length) {
          const [key] = selectedRowKeys;
          const deleted = await deleteAdministracionDePlaza(key);
          if (deleted) {
            setVisibleDelete(false);
            onCancel();
            await refreshData();
          }
        }
        setLoading(false);
      } catch (err) {
        onError(err, setLoading);
      }
    };
    return (
      <ModalDelete
        onDelete={deleteItem}
        onCancel={() => setVisibleDelete(false)}
        open={visibleDelete}
        content="Administracion de Plaza"
        loading={loading}
      />
    );
  };

  const ModalForDeleteCancelada = () => {
    const deleteItem = async () => {
      try {
        setLoading(true);
        if (selectedRowKeys.length) {
          const [key] = selectedRowKeys;
          const deleted = await eliminarPermanenteAdministracionDePlaza(key);
          if (deleted) {
            setVisibleDeleteCancelada(false);
            onCancel();
            await refreshData();
          }
        }
        setLoading(false);
      } catch (err) {
        onError(err, setLoading);
      }
    };
    return (
      <ModalDelete
        onDelete={deleteItem}
        onCancel={() => setVisibleDeleteCancelada(false)}
        open={visibleDeleteCancelada}
        content="de forma permanente esta Administración de Plaza Cancelada (dejará de mostrarse en los listados)"
        loading={loading}
      />
    );
  };

  const getControls = () => {
    const controls = {};
    const customActions = [];

    // Botones estándar
    // Agregar solo en Autorización: las nuevas solicitudes de asignación se crean
    // pendientes de autorizar; Asignación solo muestra las ya autorizadas.
    if (activeTab === TAB_AUTORIZACION) {
      controls.onClickAdd = onClickAdd;
    }

    if (activeTab === TAB_AUTORIZACION) {
      controls.onClickDelete = onClickDelete;
    }
    // Editar solo si hay uno seleccionado
    // if (selectedRowKeys.length === 1) {
    //   controls.onClickEdit = onClickEdit;
    // }
    controls.onClickEdit = onClickEdit;

    // Excel siempre disponible
    customActions.push({
      icon: <FileExcelOutlined />,
      text: 'Excel Completo',
      onClick: onClickExcelCompleto,
    });
    customActions.push(seguimiento.accionSeguimiento);

    // BOTONES ESPECÍFICOS PARA EL TAB "AUTORIZACIÓN"
    if (activeTab === TAB_AUTORIZACION) {
      // 1. Botón Autorizar Masivo (Se habilita con 1 o más selecciones)
      customActions.push({
        text: `Autorizar (${selectedRowKeys.length})`,
        icon: <CheckCircleOutlined />,
        disabled: selectedRowKeys.length === 0,
        className: 'primary',
        permission: { model: 'administraciondeplaza', action: 'autorizar' },
        onClick: () => setVisibleAutorizarMasivo(true),
      });

      // 2. Botón Ver Detalle / Firmas (Se habilita SOLO con 1 selección)
      customActions.push({
        text: 'Ver Firmas / Detalle',
        icon: <EyeOutlined />,
        disabled: selectedRowKeys.length !== 1,
        className: 'primary',
        onClick: handleClickVerDetalle,
      });
    }

    // Botón Desasignar solo en Asignación
    if (activeTab === TAB_ASIGNACION) {
      controls.onClickUnasign = isBlocked
        ? () => onAlert('...')
        : () => setVisibleAlert(true);

      // Botón Cancelar: cancela directamente la asignación seleccionada (Autorizada),
      // sin pasar por el flujo formal de Desasignar Plaza (fecha de baja/liquidación).
      customActions.push({
        text: 'Cancelar',
        icon: <CloseCircleOutlined />,
        className: 'cancel',
        disabled: selectedRowKeys.length !== 1,
        permission: { model: 'administraciondeplaza', action: 'cancelar' },
        onClick: onConfirmCancelarAsignacion,
      });
    }

    // Botón Eliminar (hard-delete real) solo en Canceladas -- único tab donde
    // todo registro ya tiene estados_globales_id=5, único estado que el
    // backend acepta para este borrado permanente (ver eliminar_permanente).
    if (activeTab === TAB_CANCELADAS) {
      controls.onClickDelete = onClickDeleteCancelada;
    }

    // Botón Cancelar solo en Desasignación (revierte la Plaza a Disponible)
    if (activeTab === TAB_DESASIGNACION) {
      customActions.push({
        text: 'Cancelar',
        icon: <CloseCircleOutlined />,
        className: 'cancel',
        disabled: selectedRowKeys.length !== 1,
        permission: { model: 'administraciondeplaza', action: 'cancelar' },
        onClick: onConfirmCancelarDesasignacion,
      });
    }

    // Tab "Todos": conviven registros de todos los estatus, así que se muestran
    // todas las acciones y cada una se habilita solo si el registro
    // seleccionado está en el estatus que le corresponde (mismas reglas que en
    // su tab de origen). Eliminar y Desasignar van en el menú de Acciones
    // porque el Table comparte `disableDelete` entre ambos botones.
    if (activeTab === TAB_TODOS) {
      const seleccionados = todosData.filter((r) => selectedRowKeys.includes(r.id));
      const seleccionEnEstado = (estado) => seleccionados.length > 0
        && seleccionados.every((r) => r.estado_global_id === estado);

      controls.onClickAdd = onClickAdd;
      // Eliminar en la barra (se habilita solo con Activas, ver `disableDelete` del tab).
      controls.onClickDelete = onClickDelete;

      customActions.push({
        text: `Autorizar (${selectedRowKeys.length})`,
        icon: <CheckCircleOutlined />,
        disabled: !seleccionEnEstado(ESTATUS_ACTIVO),
        className: 'primary',
        permission: { model: 'administraciondeplaza', action: 'autorizar' },
        onClick: () => setVisibleAutorizarMasivo(true),
      });
      customActions.push({
        text: 'Ver Firmas / Detalle',
        icon: <EyeOutlined />,
        disabled: selectedRowKeys.length !== 1 || !seleccionEnEstado(ESTATUS_ACTIVO),
        className: 'primary',
        onClick: handleClickVerDetalle,
      });
      customActions.push({
        text: 'Desasignar Plaza',
        icon: <UserDeleteOutlined />,
        disabled: selectedRowKeys.length !== 1 || !seleccionEnEstado(ESTATUS_AUTORIZADO),
        permission: { model: 'administraciondeplaza', action: 'delete' },
        onClick: isBlocked ? () => onAlert('...') : () => setVisibleAlert(true),
      });
      customActions.push({
        text: 'Cancelar Asignación',
        icon: <CloseCircleOutlined />,
        className: 'cancel',
        disabled: selectedRowKeys.length !== 1 || !seleccionEnEstado(ESTATUS_AUTORIZADO),
        permission: { model: 'administraciondeplaza', action: 'cancelar' },
        onClick: onConfirmCancelarAsignacion,
      });
      customActions.push({
        text: 'Cancelar Desasignación',
        icon: <CloseCircleOutlined />,
        className: 'cancel',
        disabled: selectedRowKeys.length !== 1 || !seleccionEnEstado(ESTATUS_INACTIVO),
        permission: { model: 'administraciondeplaza', action: 'cancelar' },
        onClick: onConfirmCancelarDesasignacion,
      });
    }

    return { ...controls, customActions };
  };
  const onAutorizarMasivo = async () => {
    if (selectedRowKeys.length === 0) return;

    if (requiereObservacionesPlaza && !observacionesMasivas.trim()) {
      message.error('Las observaciones son requeridas para este paso de autorización');
      return;
    }

    try {
      setLoading(true);
      const payload = selectedRowKeys.map((id) => ({
        id,
        observaciones: observacionesMasivas,
      }));

      // Despacha la tarea en background (responde 202 inmediatamente)
      const response = await putAutorizarPlazaMasiva(payload);
      if (!response?.task_id) {
        message.error('Error al iniciar la autorización masiva.');
        return;
      }

      setVisibleAutorizarMasivo(false);
      setObservacionesMasivas('');
      setProgresoActual({ en_curso: 0, total: response.total || selectedRowKeys.length });
      setIsPolling(true);
    } catch (err) {
      const msg = err.response?.data?.message || err.message || 'Error al autorizar';
      message.error(msg);
    } finally {
      setLoading(false);
    }
  };

  const onUpload = async () => {
    try {
      await formCarga.validateFields();
      const { file } = formCarga.getFieldsValue();
      if (file) {
        setLoading(true);
        const formData = new FormData();
        formData.append('archivo', file.file);
        formData.append('sujeto', sujeto);
        const uri = baseURI.at(-1) === '/' ? baseURI : `${baseURI}/`;
        const response = await API.post(`${baseURL}${uri}`, formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        });

        if (response?.status === 202) {
          // Backend procesará en background — arrancar polling
          setVisibleModal(false);
          formCarga.resetFields();
          setProgresoImport({ en_curso: 0, total: 0 });
          setIsPollingImport(true);
        }
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };
  const onUploadDesasignar = async () => {
    try {
      await formCargaDesasignar.validateFields();
      const { file } = formCargaDesasignar.getFieldsValue();
      if (file) {
        setLoading(true);
        const formData = new FormData();
        formData.append('archivo', file.file);
        formData.append('sujeto', sujeto);
        const desasignarURI = 'catalogos/administracion-plazas-desasignar-importar-excel/';
        const response = await API.post(`${baseURL}${desasignarURI}`, formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        });

        if (response?.status === 202) {
          setVisibleModalDesasignar(false);
          formCargaDesasignar.resetFields();
          setProgresoDesasignar({ en_curso: 0, total: 0 });
          setIsPollingDesasignar(true);
        }
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const onClickObtenerPlantilla = async () => {
    try {
      setLoading(true);
      const etiquetaSujeto = SUJETO_ETIQUETA[sujeto];
      const campoIdSujeto = SUJETO_CAMPO_ID[sujeto];
      const campoNumeroCatalogo = SUJETO_CAMPO_NUMERO_CATALOGO[sujeto];
      const campoEstatusCatalogo = SUJETO_CAMPO_ESTATUS_CATALOGO[sujeto];
      const campoNombreCatalogo = SUJETO_LABEL_PROP_CATALOGO[sujeto];
      const obtenerPersonas = GET_PERSONAS_VISTA_OPTIMIZADA_POR_SUJETO[sujeto];

      // Las columnas de Carácter/Vigencia/Periodicidad del Nombramiento solo aplican a
      // Empleado (Becario/Honorario Asimilado no tienen Nombramiento, ver
      // catalogos/serializers/administraciones_de_plazas.py).
      const templateHeaders = [sujeto === SUJETO_EMPLEADO ? {
        [`${etiquetaSujeto} (Número de ${etiquetaSujeto})`]: '',
        'Plaza (Clave)': '',
        'Fecha de Asignación (YYYY-MM-DD)': '',
        'Motivos de Movimiento (Concepto)': '',
        'Carácter de Nombramiento (Descripción)': '',
        'Inicio de Vigencia del Nombramiento (YYYY-MM-DD)': '',
        'Término de Vigencia del Nombramiento (YYYY-MM-DD)': '',
        'Periodicidad del Nombramiento (quincenal/mensual/bimestral/trimestral/semestral/anual)': '',
      } : {
        [`${etiquetaSujeto} (Número de ${etiquetaSujeto})`]: '',
        'Plaza (Clave)': '',
        'Fecha de Asignación (YYYY-MM-DD)': '',
        'Motivos de Movimiento (Concepto)': '',
      }];

      const workbook = XLSX.utils.book_new();

      const worksheet = XLSX.utils.json_to_sheet(templateHeaders);
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Plantilla');

      const motivos = await getMotivosDeMovimientosDeEmpleados();
      const motivosFiltrados = (motivos || [])
        .filter((m) => [1].includes(m.tipos_de_movimientos_de_empleados))
        .map((m) => ({ Nombre: m.concepto }));
      const wsMotivos = XLSX.utils.json_to_sheet(
        motivosFiltrados.length ? motivosFiltrados : [{ Nombre: '' }],
      );
      XLSX.utils.book_append_sheet(workbook, wsMotivos, 'Motivos de Movimiento');

      if (sujeto === SUJETO_EMPLEADO) {
        const caracteresNombramiento = await getCaracteresDeNombramiento();
        const caracteresMapped = (caracteresNombramiento || [])
          .map((c) => ({ Descripción: c.descripcion }));
        const wsCaracteres = XLSX.utils.json_to_sheet(
          caracteresMapped.length ? caracteresMapped : [{ Descripción: '' }],
        );
        XLSX.utils.book_append_sheet(workbook, wsCaracteres, 'Carácter de Nombramiento');

        const wsPeriodicidad = XLSX.utils.json_to_sheet(
          PERIODICIDAD_OPCIONES.map((p) => ({ Valor: p.value, Descripción: p.label })),
        );
        XLSX.utils.book_append_sheet(workbook, wsPeriodicidad, 'Periodicidad');
      }

      const asignacionesRaw = await getAdministracionDePlazasvistaOptimized({ estado_global_id: 4 });
      const asignacionesData = asignacionesRaw?.results || asignacionesRaw || [];
      const plazasAsignadasIds = new Set(asignacionesData.map((a) => Number(a.plaza_id)));
      const personasAsignadasIds = new Set(
        asignacionesData.map((a) => Number(a[campoIdSujeto])).filter((id) => !Number.isNaN(id)),
      );

      const plazasData = await getPlazasvistaOptimized({ sujeto });
      const plazasMapped = (plazasData || [])
        .filter((p) => [1, 3].includes(Number(p.estado_plaza_id)) && !plazasAsignadasIds.has(Number(p.id)))
        .map((p) => ({
          Clave: p.clave,
          Descripción: p.descripcion,
          'Clave Área': p.directorio_area_clave,
          Área: p.directorio_area_nombre,
          'Clave Puesto': p.puesto_clave,
          Puesto: p.puesto_descripcion,
          'Estado Plaza': p.estado_plaza,
          'Tipo de Empleado': p.tipo_de_empleado,
          'Tipo de Nómina Empleado': p.tipo_nomina_empleado,
          'Tipo de Contratación': p.tipo_de_contratacion_descripcion,
          'Tiempo de Contratación': p.tiempo_de_contratacion,
          'Sueldo Diario Nominal Asignado': p.sueldo_diario_nominal_asignado,
          'Sueldo Mensual Nominal Asignado': p.sueldo_mensual_nominal_asignado,
          ID: p.id,
        }));
      const wsPlazas = XLSX.utils.json_to_sheet(
        plazasMapped.length ? plazasMapped : [{
          Clave: '',
          Descripción: '',
          'Clave Área': '',
          Área: '',
          'Clave Puesto': '',
          Puesto: '',
          'Estado Plaza': '',
          'Tipo de Empleado': '',
          'Tipo de Nómina Empleado': '',
          'Tipo de Contratación': '',
          'Tiempo de Contratación': '',
          'Sueldo Diario Nominal Asignado': '',
          'Sueldo Mensual Nominal Asignado': '',
          ID: '',
        }],
      );
      XLSX.utils.book_append_sheet(workbook, wsPlazas, 'Plazas');

      const personasResp = await obtenerPersonas();
      const personasData = personasResp?.results || personasResp || [];
      const personasMapped = (personasData || [])
        .filter((e) => !personasAsignadasIds.has(Number(e.id)))
        .map((e) => {
          const fila = {
            [`Número de ${etiquetaSujeto}`]: e[campoNumeroCatalogo],
            'No. y Nombre Completo': e[campoNombreCatalogo],
            Nombre: e.nombre,
            'Apellido Paterno': e.apellido_paterno,
            'Apellido Materno': e.apellido_materno,
            Estatus: e[campoEstatusCatalogo],
            Antigüedad: e.antiguedad_texto,
            'Antigüedad (Años)': e.antiguedad_numerico_anos,
            'Antigüedad (Días)': e.antiguedad_numerico_dias,
            ID: e.id,
          };
          // Columnas adicionales que solo existen en el catálogo de Empleado
          if (sujeto === SUJETO_EMPLEADO) {
            fila['Número de Empleado Anterior'] = e.numero_de_empleado_anterior;
            fila.RFC = e.RFC;
            fila.CURP = e.curp;
            fila['No. Seguridad Social'] = e.numero_de_seguridad_social;
            fila['Código Postal Fiscal'] = e.codigo_postal_fiscal_texto_libre;
            fila.Edad = e.edad;
          }
          return fila;
        });
      const filaVacia = personasMapped[0]
        ? Object.fromEntries(Object.keys(personasMapped[0]).map((k) => [k, '']))
        : { [`Número de ${etiquetaSujeto}`]: '', 'No. y Nombre Completo': '' };
      const wsPersonas = XLSX.utils.json_to_sheet(
        personasMapped.length ? personasMapped : [filaVacia],
      );
      XLSX.utils.book_append_sheet(workbook, wsPersonas, etiquetaSujeto);

      XLSX.writeFile(workbook, `Asignación_de_Plazas(Asignar)_${etiquetaSujeto}.xlsx`);
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const onClickObtenerPlantillaDesasignar = async () => {
    try {
      setLoading(true);
      const etiquetaSujeto = SUJETO_ETIQUETA[sujeto];
      const campoIdSujeto = SUJETO_CAMPO_ID[sujeto];
      const campoNumeroAdminPlaza = SUJETO_CAMPO_NUMERO_ADMIN_PLAZA[sujeto];
      const campoNombreAdminPlaza = SUJETO_CAMPO_NOMBRE[sujeto];

      const workbook = XLSX.utils.book_new();

      // Hoja Plantilla: vacía, solo encabezados (la Plaza (Clave) identifica el registro a desasignar)
      const emptyRow = {
        [`Número de ${etiquetaSujeto}`]: '',
        'Clave Plaza': '',
        'Es Baja (SI/NO)': '',
        'Liquidación (Concepto)': '',
        'Fecha Desasignar (YYYY-MM-DD)': '',
        'Motivos de Movimiento (Concepto)': '',
      };
      const worksheet = XLSX.utils.json_to_sheet([emptyRow]);
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Plantilla');

      // Hoja de referencia: Asignación de Plazas (Actuales) — asignaciones autorizadas (estado global 4)
      // del sujeto seleccionado, mismas columnas que la página Asignación de Plazas > tab Asignación.
      const asignacionesRaw = await getAdministracionDePlazasvistaOptimized({
        estado_global_id: 4,
        sujeto,
      });
      const asignacionesData = (asignacionesRaw?.results || asignacionesRaw || [])
        .filter((a) => a[campoIdSujeto] != null);
      const emptyActualRow = {
        [`Número de ${etiquetaSujeto}`]: '',
        'Clave Plaza': '',
        'Fecha de Registro': '',
        'Fecha de Asignación': '',
        [`Número y Nombre del ${etiquetaSujeto}`]: '',
        Plaza: '',
        Área: '',
        Puesto: '',
        Estatus: '',
      };
      const actualesData = asignacionesData.length
        ? asignacionesData.map((a) => ({
          [`Número de ${etiquetaSujeto}`]: a[campoNumeroAdminPlaza] || '',
          'Clave Plaza': a.clave || '',
          'Fecha de Registro': a.fecha_alta ? moment(a.fecha_alta).format('DD/MM/YYYY') : '',
          'Fecha de Asignación': a.fecha_asignacion ? moment(a.fecha_asignacion).format('DD/MM/YYYY') : '',
          [`Número y Nombre del ${etiquetaSujeto}`]: a[campoNombreAdminPlaza] || '',
          Plaza: a.clave_y_descripcion || '',
          Área: a.directorio_area_clave_y_nombre || '',
          Puesto: a.puesto_clave_y_descripcion || '',
          Estatus: a.estado_global_descripcion || '',
        }))
        : [emptyActualRow];
      const wsActuales = XLSX.utils.json_to_sheet(actualesData);
      XLSX.utils.book_append_sheet(workbook, wsActuales, 'Asignación de Plazas (Actuales)');

      // Hoja de referencia: Motivos de Movimiento (tipo 2 = desasignación/baja)
      const motivos = await getMotivosDeMovimientosDeEmpleados();
      const motivosFiltrados = (motivos || [])
        .filter((m) => [2].includes(m.tipos_de_movimientos_de_empleados))
        .map((m) => ({ Nombre: m.concepto }));
      const wsMotivos = XLSX.utils.json_to_sheet(
        motivosFiltrados.length ? motivosFiltrados : [{ Nombre: '' }],
      );
      XLSX.utils.book_append_sheet(workbook, wsMotivos, 'Motivos de Movimiento');

      // Hoja de referencia: Liquidaciones (join con motivos para mostrar concepto)
      const [liquidacionesData, motivosLiqData] = await Promise.all([
        getLiquidaciones(),
        getMotivosDeLiquidaciones(),
      ]);
      const liquidacionesList = liquidacionesData?.results || liquidacionesData || [];
      const motivosLiqList = motivosLiqData?.results || motivosLiqData || [];
      const motivosLiqMap = Object.fromEntries(motivosLiqList.map((m) => [m.id, m.motivo || '']));
      const liquidacionesMapped = liquidacionesList.map((l) => ({
        Clave: l.clave || '',
        Concepto: motivosLiqMap[l.motivo_de_liquidacion] || '',
        Especificación: l.especificacion || '',
      }));
      const wsLiquidaciones = XLSX.utils.json_to_sheet(
        liquidacionesMapped.length ? liquidacionesMapped : [{ Clave: '', Concepto: '', Especificación: '' }],
      );
      XLSX.utils.book_append_sheet(workbook, wsLiquidaciones, 'Liquidaciones');

      XLSX.writeFile(workbook, `Asignación_de_Plazas(Desasignar)_${etiquetaSujeto}.xlsx`);
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const onClickCargar = () => {
    setVisibleModal(true);
  };

  const onClickCargarDesasignar = () => {
    setVisibleModalDesasignar(true);
  };

  const menuImport = (
    <Menu
      items={[
        {
          key: 1,
          label: 'Obtener Plantilla',
          icon: <FileExcelOutlined />,
          onClick: () => onClickObtenerPlantilla(),
        },
        {
          key: 2,
          label: 'Cargar',
          icon: <DownloadOutlined />,
          onClick: () => onClickCargar(),
        },
      ]}
    />
  );

  const menuImportDesasignar = (
    <Menu
      items={[
        {
          key: 1,
          label: 'Obtener Plantilla',
          icon: <FileExcelOutlined />,
          onClick: () => onClickObtenerPlantillaDesasignar(),
        },
        {
          key: 2,
          label: 'Cargar',
          icon: <DownloadOutlined />,
          onClick: () => onClickCargarDesasignar(),
        },
      ]}
    />
  );

  //  CONFIGURACIÓN DE TABLA COMÚN
  const commonTableProps = {
    cols: columns,
    baseURI: '', // Vacío para evitar fetch automático
    rowSelection,
    handleOnRowClick,
    controls: getControls(),
    permission,
    pagination: { pageSize: 10 },
    paginationCallback: null,
  };

  // Reporte de Movimientos (ficha 186): misma opción en el Exportar de todas las pestañas
  const itemsReporteMovimientos = [{
    key: 'reporte_movimientos_plazas',
    label: 'Reporte de Movimientos de Plazas',
    icon: <FileExcelOutlined />,
    onClick: () => setShowReporteMovimientos(true),
  }];

  // DEFINICIÓN DE PESTAÑAS
  const tabItems = [
    {
      key: TAB_TODOS,
      label: 'Todos',
      children: (
        seguimiento.conBarra(<Table
          cols={[seguimiento.columnaSeguimiento, ...columns]}
          baseURI=""
          rowSelection={rowSelection}
          handleOnRowClick={handleOnRowClick}
          controls={getControls()}
          customActions={getControls().customActions}
          customActionsDropdown
          permission={permission}
          pagination={{ pageSize: 10 }}
          paginationCallback={null}
          data={todosData}
          count={todosData.length}
          titleTable="Administración de Plazas - Todos"
          onExportExcel={() => onClickExcelCompleto(todosData)}
          extraExportItems={itemsReporteMovimientos}
          allowUnasign={false}
          // Eliminar solo aplica a asignaciones Activas (pendientes de autorizar).
          disableDelete={!todosData.some((r) => r.id === selectedRowKeys[0] && r.estado_global_id === ESTATUS_ACTIVO)
            || selectedRowKeys.length !== 1}
        />)
      ),
    },
    {
      key: TAB_AUTORIZACION,
      label: 'Autorización',
      children: (
        seguimiento.conBarra(<Table
          cols={[seguimiento.columnaSeguimiento, ...columns]}
          rowSelection={{
            selectedRowKeys,
            type: 'checkbox',
            // Checkbox propio en el encabezado (patrón de ConsultasDeNombramientos):
            // lee del dataset completo/filtrado y no solo de la página actual,
            // a diferencia de `onSelectAll` de AntD.
            columnTitle: (
              <Checkbox
                checked={selectedRowKeys.length > 0
                  && selectedRowKeys.length === autorizacionEffectiveData.length}
                indeterminate={selectedRowKeys.length > 0
                  && selectedRowKeys.length < autorizacionEffectiveData.length}
                onChange={(e) => {
                  if (e.target.checked) {
                    setSelectedRowKeys(autorizacionEffectiveData.map((row) => row.id));
                  } else {
                    setSelectedRowKeys([]);
                  }
                }}
              />
            ),
            onSelect: (record, selected) => {
              if (selected) {
                setSelectedRowKeys((prev) => [...prev, record.id]);
              } else {
                setSelectedRowKeys((prev) => prev.filter((k) => k !== record.id));
              }
            },
            onChange: (keys) => {
              setSelectedRowKeys(keys);
            },
          }}
          handleOnRowClick={handleOnRowClick}
          controls={getControls()}
          customActions={getControls().customActions}
          customActionsDropdown
          permission={permission}
          data={autorizacionData}
          count={autorizacionData.length}
          titleTable="Plazas Pendientes de Autorización (Activas)"
          onExportExcel={() => onClickExcelCompleto(autorizacionData)}
          extraExportItems={itemsReporteMovimientos}
          allowUnasign={false}
          allowMultiSelect
          allowMultiDeselect
          onMultiSelect={handleAutorizacionMultiSelect}
          onMultiDeselect={handleAutorizacionMultiDeselect}
          onTableChange={handleAutorizacionTableChange}
        />)
      ),
    },
    {
      key: TAB_ASIGNACION,
      label: 'Asignación',
      children: (
        seguimiento.conBarra(<Table
          cols={[seguimiento.columnaSeguimiento, ...columns]}
          baseURI=""
          rowSelection={rowSelection}
          handleOnRowClick={handleOnRowClick}
          controls={getControls()}
          customActions={getControls().customActions}
          customActionsDropdown
          permission={permission}
          pagination={{ pageSize: 10 }}
          paginationCallback={null}
          data={asignacionData}
          count={asignacionData.length}
          titleTable="Administración de Plazas - Asignadas"
          allowUnasign
          groupImports
          allowCustomImport
          customImportMenu={menuImport}
          customImportText="Importar Plazas  Asignadas"
          onExportExcel={() => onClickExcelCompleto(asignacionData)}
          extraExportItems={itemsReporteMovimientos}
        />)
      ),
    },
    {
      key: TAB_DESASIGNACION,
      label: 'Desasignación',
      children: (
        seguimiento.conBarra(<Table
          cols={[seguimiento.columnaSeguimiento, ...columns]}
          baseURI=""
          rowSelection={rowSelection}
          handleOnRowClick={handleOnRowClick}
          controls={getControls()}
          customActions={getControls().customActions}
          customActionsDropdown
          permission={permission}
          pagination={{ pageSize: 10 }}
          paginationCallback={null}
          data={desasignacionData}
          count={desasignacionData.length}
          titleTable="Histórico de Desasignaciones"
          onExportExcel={() => onClickExcelCompleto(desasignacionData)}
          extraExportItems={itemsReporteMovimientos}
          allowUnasign={false}
          groupImports
          allowCustomImport
          customImportMenu={menuImportDesasignar}
          customImportText="Importar Plazas Desasignadas"
        />)
      ),
    },
    {
      key: TAB_CANCELADAS,
      label: 'Canceladas',
      children: (
        seguimiento.conBarra(<Table
          cols={[seguimiento.columnaSeguimiento, ...columns]}
          baseURI=""
          rowSelection={rowSelection}
          handleOnRowClick={handleOnRowClick}
          controls={getControls()}
          customActions={getControls().customActions}
          customActionsDropdown
          permission={permission}
          pagination={{ pageSize: 10 }}
          paginationCallback={null}
          data={canceladasData}
          count={canceladasData.length}
          titleTable="Desasignaciones Canceladas"
          onExportExcel={() => onClickExcelCompleto(canceladasData)}
          extraExportItems={itemsReporteMovimientos}
          allowUnasign={false}
          // Defensa en profundidad: aunque este tab ya solo trae registros
          // Cancelados (filtrados en el cliente), se revalida el estado aquí
          // -- el backend (`eliminar_permanente`) vuelve a validarlo también.
          disableDelete={!canceladasData.some((r) => r.id === selectedRowKeys[0] && r.estado_global_id === ESTATUS_CANCELADO)
            || selectedRowKeys.length !== 1}
        />)
      ),
    },
  ];

  // Los datos del Nombramiento solo se capturan/corrigen mientras la Asignación
  // sigue pendiente de autorizar (estados_globales=1, Activo -- tab Autorización).
  // Ya Autorizada, Desasignada o Cancelada, estos campos deben verse solo de
  // lectura: el Nombramiento real ya se generó (o nunca se generará) con esos
  // datos y no debe poder alterarse desde aquí.
  const nombramientoEditable = !isEditing || registroEstadosGlobales === ESTATUS_ACTIVO;

  const selectorDeSujeto = (
    <Col xs={24} sm={12} md={8} style={{ marginBottom: 16 }}>
      <div style={{ marginBottom: 4 }}>Tipo de Sujeto</div>
      <AntdSelect
        aria-label="Tipo de Sujeto"
        style={{ width: '100%' }}
        value={sujeto}
        onChange={(value) => { setSujeto(value); onCancel(); }}
        options={sujetosDeNomina.map((s) => ({ value: s.slug, label: s.etiqueta }))}
      />
    </Col>
  );

  return (
    <Row className="container">
      <Spin tip="Cargando..." spinning={loading}>
        {!open ? (
          // VISTA DE TABLA CON PESTAÑAS
          <Card bordered={false} className="tables-container">
            <Row>{selectorDeSujeto}</Row>
            <Tabs
              defaultActiveKey={TAB_TODOS}
              activeKey={activeTab}
              onChange={setActiveTab}
              items={tabItems}
            />
          </Card>
        ) : (
          // VISTA DE FORMULARIO
          <Card
            className="form-container"
            title={`${selectedRowKeys.length ? 'Editar' : 'Agregar'} Asignación de Plaza ${SUJETO_ETIQUETA[sujeto]}`}
            extra={(
              <FormSubmitControls
                onFinish={() => form.submit()}
                onCancel={onCancel}
                loading={loading}
                allowSave={!isEditing || registroEstadosGlobales === ESTATUS_ACTIVO}
              />
            )}
            bordered={false}
          >
            {seguimiento.envolverConSeguimiento(
              <Form
                layout="vertical"
                form={form}
                onFinish={onFinish}
                scrollToFirstError
                name="general"
              >
                <Row gutter={10}>
                  {/*  CAMPOS DEL FORMULARIO  */}
                  <Col xs={24} sm={24} md={8}>
                    <Form.Item name={nameAlta} label="Fecha de Registro" rules={rules.required} hasFeedback>
                      <DatePicker allowClear format="DD/MM/YYYY" disabled />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={8}>
                    <Form.Item name="fecha_asignacion" label="Fecha de Asignación de Plaza" rules={rules.startDate} hasFeedback>
                      <DatePicker allowClear format="DD/MM/YYYY" disabled={isEditing && registroEstadosGlobales !== ESTATUS_ACTIVO} />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={8}>
                    <Form.Item name={nameEmpleado} label={SUJETO_ETIQUETA[sujeto]} rules={rules.required} hasFeedback>
                      {isEditing ? (
                        <Select
                          dataSource={empleadoNombre}
                          labelProp={SUJETO_LABEL_PROP_ADMIN_PLAZA[sujeto]}
                          keyProp="id"
                          disabled
                        />
                      ) : (
                        <Select
                          dataSource={empleadosFiltered}
                          labelProp={SUJETO_LABEL_PROP_CATALOGO[sujeto]}
                          keyProp="id"
                          onChange={onChangeEmpleado}
                          disabled={selectedRowKeys.length > 0}
                        />
                      )}
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={8}>
                    <Form.Item name={nameInicioVigencia} label="Fecha de Inicio de Vigencia" rules={rules.required} hasFeedback>
                      <DatePicker allowClear format="DD/MM/YYYY" disabled={isEditing ? registroEstadosGlobales !== ESTATUS_ACTIVO : disableAsignacion} />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={8}>
                    <Form.Item name="plaza" label="Número Clave Plaza" rules={rules.required} hasFeedback>
                      <Select
                        keyProp="id"
                        labelProp="clave_y_descripcion"
                        dataSource={plazasFiltered}
                        onChange={onChangePlaza}
                        disabled={selectedRowKeys.length > 0}
                        render={(val) => val?.clave_y_descripcion}
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={8}><Form.Item label="Área"><Input disabled value={area} /></Form.Item></Col>
                  <Col xs={24} sm={24} md={8}><Form.Item label="Puesto"><Input disabled value={puesto} /></Form.Item></Col>
                  <Col xs={24} sm={24} md={8}><Form.Item label="Tipo de Empleado"><Input disabled value={tipoEmpleadoDisplay} /></Form.Item></Col>
                  <Col xs={24} sm={24} md={8}><Form.Item label="Categoría de Empleado"><Input disabled value={categoria} /></Form.Item></Col>
                  <Col xs={24} sm={24} md={8}><Form.Item label="Tipo de Nómina Empleado"><Input disabled value={nominaDisplay} /></Form.Item></Col>
                  <Col xs={24} sm={24} md={8}><Form.Item label="Tipo de Empleado Presupuestal"><Input disabled value={tipoEmpleadoPresupuestal} /></Form.Item></Col>
                  <Col xs={24} sm={24} md={8}><Form.Item label="Tiempo de Contratación"><Input disabled value={tiempoContratacion} /></Form.Item></Col>
                  <Col xs={24} sm={24} md={8}><Form.Item label="Clase de Contratación"><Input disabled value={claseContratacion} /></Form.Item></Col>
                  <Col xs={24} sm={24} md={8}><Form.Item label="Sueldo Diario Nominal"><CurrencyInput disabled value={sueldoDiario} /></Form.Item></Col>
                  <Col xs={24} sm={24} md={8}><Form.Item label="Sueldo Mensual Nominal"><CurrencyInput disabled value={sueldoMensual} /></Form.Item></Col>

                  <Col xs={24} sm={24} md={8}>
                    <Form.Item name="tipo_de_actividad" label="Tipo de Actividad" hasFeedback>
                      <Select
                        keyProp="id"
                        labelProp="concepto"
                        dataSource={tiposDeActividad}
                        disabled={isEditing && registroEstadosGlobales !== ESTATUS_ACTIVO}
                        render={(item) => (item ? `${item.clave} - ${item.concepto}` : '')}
                      />
                    </Form.Item>
                  </Col>

                  <Col xs={24} sm={24} md={8}>
                    <Form.Item name="tipo_de_asignacion_de_plaza" label="Tipo de Asignación" hasFeedback>
                      <Select labelProp="nombre" keyProp="id" dataSource={tiposDeAsignacion} disabled={isEditing && registroEstadosGlobales !== ESTATUS_ACTIVO} />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={8}>
                    <Form.Item name="motivo_asignacion" label="Motivo de Asignación de Plaza" rules={rules.required} hasFeedback>
                      <Select
                        dataSource={motivosMovimiento.filter((e) => (
                          e.tipos_de_movimientos_de_empleados === TIPO_MOVIMIENTO_ALTA
                        || e.tipos_de_movimientos_de_empleados === TIPO_MOVIMIENTO_CAMBIO
                        ))}
                        render={(value) => {
                          if (!value) return '';
                          const tipo = tiposDeMovimientosDeEmpleados.find(
                            (t) => t.id === value.tipos_de_movimientos_de_empleados,
                          );
                          return `${value.concepto} - ${tipo?.descripcion || ''}`;
                        }}
                        disabled={isEditing && registroEstadosGlobales !== ESTATUS_ACTIVO}
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={8}>
                    <Form.Item name="tipo_de_movimiento" label="Tipo de Movimiento de Personal" hasFeedback>
                      <Select
                        labelProp="concepto"
                        keyProp="id"
                        dataSource={tiposDeMovimientoDePersonal}
                        disabled={isEditing && registroEstadosGlobales !== ESTATUS_ACTIVO}
                      />
                    </Form.Item>
                  </Col>

                  <Col xs={24} sm={24} md={8}>
                    <Form.Item name={selectedRowData?.es_baja ? 'fecha_baja' : 'fecha_desasignacion'} label={selectedRowData?.es_baja ? 'Fecha de Baja' : 'Fecha de Desasignación'} rules={rules.endDate} hasFeedback>
                      <DatePicker allowClear format="DD/MM/YYYY" placeholder="" disabled />
                    </Form.Item>
                  </Col>

                  <Col xs={24} sm={24} md={8}>
                    <Form.Item name="motivo_desasignacion" label={selectedRowData?.es_baja ? 'Motivo de Baja' : 'Motivo de Desasignación'} rules={rules.endDate} hasFeedback>
                      <Select dataSource={motivosMovimiento} render={(value) => `${value?.concepto}`} disabled />
                    </Form.Item>
                  </Col>

                  {sujeto === SUJETO_EMPLEADO && (
                    <>
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item name="aplica_nombramiento" valuePropName="checked" label=" ">
                          <Checkbox disabled={!nombramientoEditable}>Aplica Nombramiento</Checkbox>
                        </Form.Item>
                      </Col>

                      <Form.Item
                        noStyle
                        shouldUpdate={(prev, cur) => (
                          prev.aplica_nombramiento !== cur.aplica_nombramiento
                          || prev.inicio_vigencia_nombramiento !== cur.inicio_vigencia_nombramiento
                          || prev.termino_vigencia_nombramiento !== cur.termino_vigencia_nombramiento
                          || prev.periodicidad_nombramiento !== cur.periodicidad_nombramiento
                        )}
                      >
                        {({ getFieldValue }) => getFieldValue('aplica_nombramiento') && (
                          <>
                            <Col xs={24} sm={24} md={8}>
                              <Form.Item name="caracter_de_nombramiento" label="Carácter de Nombramiento" rules={rules.required} hasFeedback>
                                <Select dataSource={caracteresDeNombramiento} keyProp="id" labelProp="descripcion" disabled={!nombramientoEditable} />
                              </Form.Item>
                            </Col>
                            <Col xs={24} sm={24} md={8}>
                              <Form.Item name="inicio_vigencia_nombramiento" label="Inicio de Vigencia del Nombramiento" rules={rules.required} hasFeedback>
                                <DatePicker
                                  allowClear
                                  format="DD/MM/YYYY"
                                  style={{ width: '100%' }}
                                  disabled={!nombramientoEditable}
                                  onChange={() => setTimeout(recalcularPeriodosNombramiento, 0)}
                                />
                              </Form.Item>
                            </Col>
                            <Col xs={24} sm={24} md={8}>
                              <Form.Item name="termino_vigencia_nombramiento" label="Término de Vigencia del Nombramiento" rules={rules.required} hasFeedback>
                                <DatePicker
                                  allowClear
                                  format="DD/MM/YYYY"
                                  style={{ width: '100%' }}
                                  disabled={!nombramientoEditable}
                                  onChange={() => setTimeout(recalcularPeriodosNombramiento, 0)}
                                />
                              </Form.Item>
                            </Col>
                            <Col xs={24} sm={24} md={8}>
                              <Form.Item
                                name="periodicidad_nombramiento"
                                label="Periodicidad del Nombramiento"
                                extra="Selecciona una periodicidad para generar nombramientos por periodo. Deja vacío para un solo nombramiento."
                              >
                                <AntdSelect
                                  allowClear
                                  placeholder="Sin periodicidad (un solo nombramiento)"
                                  options={PERIODICIDAD_OPCIONES}
                                  style={{ width: '100%' }}
                                  disabled={!nombramientoEditable}
                                  onChange={() => setTimeout(recalcularPeriodosNombramiento, 0)}
                                />
                              </Form.Item>
                            </Col>
                            {periodosNombramiento.length > 0 && (
                              <Col span={24}>
                                <AntTable
                                  size="small"
                                  pagination={false}
                                  dataSource={periodosNombramiento}
                                  rowKey="key"
                                  title={() => (
                                    <Typography.Text strong>
                                      {`Periodos a generar: ${periodosNombramiento.length}`}
                                    </Typography.Text>
                                  )}
                                  columns={[
                                    {
                                      title: '#',
                                      key: 'num',
                                      width: 50,
                                      align: 'center',
                                      render: (_v, _r, i) => i + 1,
                                    },
                                    {
                                      title: 'Fecha Inicial',
                                      dataIndex: 'inicio',
                                      render: (val, record) => (
                                        <DatePicker
                                          size="small"
                                          format="YYYY-MM-DD"
                                          value={moment(val)}
                                          style={{ width: '100%' }}
                                          getPopupContainer={(t) => t.parentNode}
                                          onChange={(date) => {
                                            if (!date) return;
                                            setPeriodosNombramiento((prev) => prev.map((item) => (
                                              item.key === record.key
                                                ? { ...item, inicio: date.format('YYYY-MM-DD') }
                                                : item
                                            )));
                                          }}
                                        />
                                      ),
                                    },
                                    {
                                      title: 'Fecha Final',
                                      dataIndex: 'fin',
                                      render: (val, record) => (
                                        <DatePicker
                                          size="small"
                                          format="YYYY-MM-DD"
                                          value={moment(val)}
                                          style={{ width: '100%' }}
                                          getPopupContainer={(t) => t.parentNode}
                                          onChange={(date) => {
                                            if (!date) return;
                                            setPeriodosNombramiento((prev) => prev.map((item) => (
                                              item.key === record.key
                                                ? { ...item, fin: date.format('YYYY-MM-DD') }
                                                : item
                                            )));
                                          }}
                                        />
                                      ),
                                    },
                                  ]}
                                />
                              </Col>
                            )}
                          </>
                        )}
                      </Form.Item>
                    </>
                  )}

                  <Col xs={24} sm={24} md={8}>
                    <Form.Item name="aplica_retroactivo" valuePropName="checked" label=" ">
                      <Checkbox disabled={isEditing && registroEstadosGlobales !== ESTATUS_ACTIVO}>
                        Aplica Retroactivo
                      </Checkbox>
                    </Form.Item>
                  </Col>

                  <Form.Item
                    noStyle
                    shouldUpdate={(prev, cur) => (
                      prev.aplica_retroactivo !== cur.aplica_retroactivo
                    )}
                  >
                    {({ getFieldValue }) => getFieldValue('aplica_retroactivo') && (
                      <>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="periodo_fiscal_retroactivo"
                            label="Periodo Fiscal"
                            rules={[{ required: true, message: 'Selecciona un Periodo Fiscal' }]}
                          >
                            <AntdSelect
                              allowClear
                              placeholder="Selecciona un Periodo Fiscal"
                              showSearch
                              optionFilterProp="children"
                              style={{ width: '100%' }}
                              disabled={!tipoNominaEmpleadoPlaza
                                || (isEditing && registroEstadosGlobales !== ESTATUS_ACTIVO)}
                              onChange={onChangePeriodoFiscalRetroactivo}
                            >
                              {periodosFiscales.map((pf) => (
                                <AntdSelect.Option key={pf.id} value={pf.id}>
                                  {pf.periodo}
                                </AntdSelect.Option>
                              ))}
                            </AntdSelect>
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="periodo_de_pago_retroactivo"
                            label="Periodo de Pago"
                            rules={[{ required: true, message: 'Selecciona un Periodo de Pago' }]}
                          >
                            <AntdSelect
                              allowClear
                              placeholder="Selecciona un Periodo de Pago"
                              showSearch
                              optionFilterProp="children"
                              style={{ width: '100%' }}
                              disabled={!tipoNominaEmpleadoPlaza || !periodosDeNominaDetalle.length
                                || (isEditing && registroEstadosGlobales !== ESTATUS_ACTIVO)}
                            >
                              {periodosDeNominaDetalle.map((pnd) => (
                                <AntdSelect.Option key={pnd.id} value={pnd.id}>
                                  {`${pnd.numero_de_nomina} (${pnd.fecha_inicial} al ${pnd.fecha_final})`}
                                </AntdSelect.Option>
                              ))}
                            </AntdSelect>
                          </Form.Item>
                        </Col>
                      </>
                    )}
                  </Form.Item>

                  <Col xs={24} sm={24} md={8}>
                    <Form.Item name="estado_plaza" label="Estatus" rules={rules.required} hasFeedback initialValue={ESTADO_PLAZA_ASIGNADA}>
                      <Select dataSource={estados} disabled />
                    </Form.Item>
                  </Col>
                </Row>
                <Form.Item hidden><Button htmlType="submit" /></Form.Item>
              </Form>,
              'esta Asignación de Plaza',
            )}
          </Card>
        )}

        {seguimiento.modalSeguimiento}
        <Modal
          open={visibleAutorizarMasivo}
          title="Confirmar Autorización Masiva"
          okText="Autorizar"
          cancelText="Cancelar"
          onCancel={() => setVisibleAutorizarMasivo(false)}
          onOk={onAutorizarMasivo}
        >
          <p>
            Se autorizarán
            {' '}
            <b>{selectedRowKeys.length}</b>
            {' '}
            registros seleccionados.
          </p>
          <Input.TextArea
            rows={4}
            placeholder={`Observaciones generales...${requiereObservacionesPlaza ? ' (requerido)' : ''}`}
            value={observacionesMasivas}
            status={requiereObservacionesPlaza && !observacionesMasivas.trim() ? 'error' : undefined}
            onChange={(e) => setObservacionesMasivas(e.target.value)}
          />
        </Modal>

        {/* MODAL : PROGRESO AUTORIZACIÓN MASIVA */}
        <Modal
          open={isPolling}
          title="Autorizando Plazas..."
          footer={null}
          closable={false}
          maskClosable={false}
          centered
        >
          <div style={{ textAlign: 'center', padding: '16px 0' }}>
            <Progress
              type="circle"
              percent={
                progresoActual.total > 0
                  ? Math.round((progresoActual.en_curso / progresoActual.total) * 100)
                  : 0
              }
            />
            <p style={{ marginTop: 16 }}>
              {progresoActual.en_curso}
              {' / '}
              {progresoActual.total}
              {' registros procesados'}
            </p>
          </div>
        </Modal>

        {/* MODAL : ERRORES DE AUTORIZACIÓN MASIVA */}
        <Modal
          open={modalErroresVisible}
          title={`Errores en autorización masiva (${erroresAutorizacion.length})`}
          onCancel={() => setModalErroresVisible(false)}
          footer={[
            <Button key="cerrar" type="primary" onClick={() => setModalErroresVisible(false)}>
              Cerrar
            </Button>,
          ]}
          centered
          width={640}
        >
          <List
            size="small"
            dataSource={erroresAutorizacion}
            renderItem={(item) => (
              <List.Item>
                <span style={{ color: '#cf1322' }}>{item}</span>
              </List.Item>
            )}
          />
        </Modal>

        {/* MODAL : PROGRESO IMPORTACIÓN EXCEL */}
        <Modal
          open={isPollingImport}
          title="Importando Plazas..."
          footer={null}
          closable={false}
          maskClosable={false}
          centered
        >
          <div style={{ textAlign: 'center', padding: '16px 0' }}>
            <Progress
              type="circle"
              percent={
                progresoImport.total > 0
                  ? Math.round((progresoImport.en_curso / progresoImport.total) * 100)
                  : 0
              }
            />
            <p style={{ marginTop: 16 }}>
              {progresoImport.en_curso}
              {' / '}
              {progresoImport.total}
              {' registros procesados'}
            </p>
          </div>
        </Modal>

        {/* MODAL : CARGA MASIVA EXCEL */}
        <Modal
          open={visibleModal}
          title={(
            <FormSubmitControls
              label={`Carga Masiva — ${SUJETO_ETIQUETA[sujeto]}`}
              onFinish={onUpload}
              onCancel={() => {
                setVisibleModal(false);
                formCarga.resetFields();
              }}
              loading={loading}
            />
          )}
          onCancel={() => {
            setVisibleModal(false);
            formCarga.resetFields();
          }}
          footer={null}
          closable={false}
          maskClosable={!loading}
          keyboard={!loading}
          forceRender
          destroyOnClose
        >
          <Spin tip="Cargando..." spinning={loading}>
            <Form
              layout="vertical"
              form={formCarga}
              name="carga"
              onFinish={onUpload}
            >
              <Dragger
                label="Archivo"
                limitMB={30}
                rules={[{ required: true, message: 'El archivo es requerido' }]}
                name="file"
                allowedExtensions={['xlsx']}
              />
            </Form>
          </Spin>
        </Modal>

        {/* MODAL : PROGRESO IMPORTACIÓN EXCEL DESASIGNAR */}
        <Modal
          open={isPollingDesasignar}
          title="Desasignando Plazas..."
          footer={null}
          closable={false}
          maskClosable={false}
          centered
        >
          <div style={{ textAlign: 'center', padding: '16px 0' }}>
            <Progress
              type="circle"
              percent={
                progresoDesasignar.total > 0
                  ? Math.round((progresoDesasignar.en_curso / progresoDesasignar.total) * 100)
                  : 0
              }
            />
            <p style={{ marginTop: 16 }}>
              {progresoDesasignar.en_curso}
              {' / '}
              {progresoDesasignar.total}
              {' registros procesados'}
            </p>
          </div>
        </Modal>

        {/* MODAL : CARGA MASIVA EXCEL DESASIGNAR */}
        <Modal
          open={visibleModalDesasignar}
          title={(
            <FormSubmitControls
              label={`Carga Masiva (Desasignar) — ${SUJETO_ETIQUETA[sujeto]}`}
              onFinish={onUploadDesasignar}
              onCancel={() => {
                setVisibleModalDesasignar(false);
                formCargaDesasignar.resetFields();
              }}
              loading={loading}
            />
          )}
          onCancel={() => {
            setVisibleModalDesasignar(false);
            formCargaDesasignar.resetFields();
          }}
          footer={null}
          closable={false}
          maskClosable={!loading}
          keyboard={!loading}
          forceRender
          destroyOnClose
        >
          <Spin tip="Cargando..." spinning={loading}>
            <Form
              layout="vertical"
              form={formCargaDesasignar}
              name="carga_desasignar"
              onFinish={onUploadDesasignar}
            >
              <Dragger
                label="Archivo"
                limitMB={30}
                rules={[{ required: true, message: 'El archivo es requerido' }]}
                name="file"
                allowedExtensions={['xlsx']}
              />
            </Form>
          </Spin>
        </Modal>

        {/* MODAL : DETALLE DE FIRMAS */}
        <AutorizacionPlazaDetalleModal
          open={visibleDetalle}
          onClose={() => {
            setVisibleDetalle(false);
            setRecordParaDetalle(null);
          }}
          idAdministracionPlaza={recordParaDetalle?.id}
          empleadoNombre={recordParaDetalle?.numero_y_nombre_empleado}
          onSuccessAutorizacion={() => refreshData()}
        />
        <ModalForDelete />
        <ModalForDeleteCancelada />
        <ModalUnAsignPlaza
          onUnasign={() => onUnasign()}
          onCancel={() => onCancel()}
          open={visibleAlert}
          loading={loading}
          form={form}
          rules={rules}
          motivosMovimiento={motivosMovimiento}
        />
        <ModalConfirmation
          onFinish={onCancelarDesasignacion}
          onCancel={() => setVisibleCancelarDesasignacion(false)}
          open={visibleCancelarDesasignacion}
          ConfirmCancel
          contentTitle="Cancelar la desasignación seleccionada"
          extraContent="La Plaza asociada volverá a estar Disponible para su selección."
          loading={loading}
        />
        <ModalConfirmation
          onFinish={onCancelarAsignacion}
          onCancel={() => setVisibleCancelarAsignacion(false)}
          open={visibleCancelarAsignacion}
          ConfirmCancel
          contentTitle="Cancelar la asignación seleccionada"
          extraContent="La Plaza asociada volverá a estar Disponible para su selección."
          loading={loading}
        />
        <ExportadorExcelPersonalizado
          visible={showExportador}
          onCancel={() => setShowExportador(false)}
          data={datosParaExportar}
          fileName={`AdministracionPlazas_${moment().format('YYYY-MM-DD')}`}
          sheetName="AsignacionPlazas"
        />
        <ReporteMovimientosModal
          open={showReporteMovimientos}
          onClose={() => setShowReporteMovimientos(false)}
          tipo="plazas"
          titulo="Reporte de Movimientos de Plazas"
          hojas={[
            {
              key: 'asignaciones',
              nombre: 'Asignación',
              titulo: 'ASIGNACIÓN DE PLAZAS',
              columnas: [
                { header: 'Motivo', key: 'motivo', width: 34 },
                { header: 'Tipo de Sujeto', key: 'tipo_de_sujeto', width: 18 },
                {
                  header: 'Sueldo Mensual Asignado', key: 'sueldo_mensual', width: 16, numFmt: FORMATO_MONEDA,
                },
                { header: 'Situación Actual', key: 'situacion_actual', width: 16 },
              ],
            },
            {
              key: 'desasignaciones',
              nombre: 'Desasignación',
              titulo: 'DESASIGNACIÓN DE PLAZAS',
              columnas: [
                { header: 'Motivo', key: 'motivo', width: 34 },
                { header: 'Tipo de Movimiento', key: 'tipo_de_movimiento', width: 16 },
                { header: 'Tipo de Sujeto', key: 'tipo_de_sujeto', width: 18 },
                {
                  header: 'Fecha de Asignación', key: 'fecha_asignacion', width: 14, fecha: true,
                },
              ],
            },
            {
              key: 'cronologico',
              nombre: 'Cronológico',
              titulo: 'MOVIMIENTOS DE PLAZAS POR EMPLEADO (CRONOLÓGICO)',
              construir: construirHojaCronologica,
            },
          ]}
          nota="Asignaciones por fecha de asignación y desasignaciones por fecha de desasignación o baja. Puesto, plaza, área y tipo de nómina son los que tenía la asignación."
          fileName="Reporte_Movimientos_Plazas"
        />
      </Spin>
    </Row>
  );
};

export default AdministracionDePlaza;
